<template>
  <div class="form form-invoice pb-4">
    <h5>{{ $t("message.contracts.document_fm1") }}</h5>
    <br />
    <div
      class="alert mt-2 alert-success rounded d-flex"
      v-if="fm1_main.IsSigned"
    >
      <span style="flex-basis: 50%">
        {{ $t("message.contracts.signed_message_" + fm1_main.SignatureType) }}
        {{ fm1_main.SignDate }}<br />
        {{ fm1_main.SignatureName }}
      </span>
    </div>
    <b-tabs pills content-class="mt-3" small>
      <b-tab
        :title="$t('message.contracts.fm1_tab1_short')"
        :title-link-attributes="{ title: $t('message.contracts.fm1_tab1') }"
      >
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <!-- <b-form-datepicker :locale="locale" v-model="fm1_main.fm1_main_date" :placeholder="$t('message.contracts.fm1_main_date')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" id="fm1_main_date"></b-form-datepicker>
					<label  v-if="fm1_main.fm1_main_date!=''"  for="fm1_main_date" class="form-label-group-label shorter topped">{{$t('message.contracts.fm1_main_date')}}</label> -->

          <datepicker
            value-type="YYYY-MM-DD"
            format="DD.MM.YYYY"
            @focus="fm1_main.fm1_main_date = ' '"
            @blur="
              fm1_main.fm1_main_date == ' '
                ? (fm1_main.fm1_main_date = '')
                : (fm1_main.fm1_main_date = fm1_main.fm1_main_date)
            "
            inputClass="form-control"
            :disabled="is_field_readonly"
            v-model="fm1_main.fm1_main_date"
            :placeholder="$t('message.contracts.fm1_main_date')"
            :inputAttr="{ id: 'fm1_main_date' }"
          />
          <label
            for="fm1_main_date"
            class="form-label-group-label shorter"
            :class="
              fm1_main.fm1_main_date != '' && fm1_main.fm1_main_date != null
                ? 'topped'
                : ''
            "
            >{{ $t("message.contracts.fm1_main_date") }}</label
          >
        </span>
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group required',
            fm1_main_doc_kind_focus ? 'focused' : '',
            $v.fm1_main.fm1_main_doc_kind.$error ? 'has-danger' : '',
          ]"
        >
          <v-select
            id="fm1_main_doc_kind"
            :disabled="is_field_readonly"
            :options="fm1_main_doc_kinds"
            label="display_text"
            :class="[
              'form-control',
              typeof fm1_main.fm1_main_doc_kind !== 'undefined' &&
              fm1_main.fm1_main_doc_kind.value !== ''
                ? 'vs--selected'
                : '',
            ]"
            v-model="fm1_main.fm1_main_doc_kind"
            :placeholder="$t('message.contracts.fm1_main_doc_kind')"
            @focus="fm1_main_doc_kind_Focused"
            @blur="fm1_main_doc_kindBlurred"
          ></v-select>
          <label
            for="fm1_main_doc_kind"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.fm1_main_doc_kind") }}</label
          >
          <label
            v-if="form_error && !$v.fm1_main.fm1_main_doc_kind.required"
            class="control-label text-danger d-block"
            >{{ $t("message.errors.required") }}</label
          >
        </span>
        <span
          :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
          v-if="
            typeof fm1_main.fm1_main_doc_kind !== 'undefined' &&
            fm1_main.fm1_main_doc_kind.value == 2
          "
        >
          <input
            :disabled="is_field_readonly"
            type="text"
            class="form-control"
            v-model="fm1_main.fm1_main_related_number"
            :placeholder="$t('message.contracts.fm1_main_doc_kind_number_2')"
            autocomplete="off"
            style="cursor: auto"
            id="fm1_main_doc_kind_number_2"
          />
          <label
            for="fm1_main_doc_kind_number_2"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.fm1_main_doc_kind_2_number") }}</label
          >
        </span>
        <span
          :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
          v-if="
            typeof fm1_main.fm1_main_doc_kind !== 'undefined' &&
            fm1_main.fm1_main_doc_kind.value == 3
          "
        >
          <input
            :disabled="is_field_readonly"
            type="text"
            class="form-control"
            v-model="fm1_main.fm1_main_related_number"
            :placeholder="$t('message.contracts.fm1_main_doc_kind_number_3')"
            autocomplete="off"
            style="cursor: auto"
            id="fm1_main_doc_kind_number_3"
          />
          <label
            for="fm1_main_doc_kind_number_3"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.fm1_main_doc_kind_3_number") }}</label
          >
        </span>
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group',
            fm1_main_form_state_focus ? 'focused' : '',
          ]"
        >
          <v-select
            :disabled="is_field_readonly"
            id="fm1_main_doc_kind"
            :options="fm1_main_form_states"
            label="display_text"
            :class="[
              'form-control',
              typeof fm1_main.fm1_main_form_state !== 'undefined' &&
              fm1_main.fm1_main_form_state.value !== ''
                ? 'vs--selected'
                : '',
            ]"
            v-model="fm1_main.fm1_main_form_state"
            :placeholder="$t('message.contracts.fm1_main_form_state')"
            @focus="fm1_main_form_state_Focused"
            @blur="fm1_main_form_stateBlurred"
          ></v-select>
          <label
            for="fm1_main_doc_kind"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.fm1_main_form_state") }}</label
          >
        </span>
        <span
          :class="['bmd-form-group mb-2 d-block form-label-group']"
          v-if="
            typeof fm1_main.fm1_main_form_state !== 'undefined' &&
            fm1_main.fm1_main_form_state.value == 1
          "
        >
          <!-- <b-form-datepicker :locale="locale" v-model="fm1_main.fm1_main_related_date" :placeholder="$t('message.contracts.fm1_main_form_state_1_date')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" id="fm1_main_form_state_1_date"></b-form-datepicker>
					<label  v-if="fm1_main.fm1_main_related_date!=''"  for="fm1_main_related_date" class="form-label-group-label shorter topped">{{$t('message.contracts.fm1_main_related_date')}}</label> -->

          <datepicker
            value-type="YYYY-MM-DD"
            format="DD.MM.YYYY"
            @focus="fm1_main.fm1_main_related_date = ' '"
            @blur="
              fm1_main.fm1_main_related_date == ' '
                ? (fm1_main.fm1_main_related_date = '')
                : (fm1_main.fm1_main_related_date =
                    fm1_main.fm1_main_related_date)
            "
            inputClass="form-control"
            :disabled="is_field_readonly"
            v-model="fm1_main.fm1_main_related_date"
            :placeholder="$t('message.contracts.fm1_main_related_date')"
            :inputAttr="{ id: 'fm1_main_related_date' }"
          />
          <label
            for="fm1_main_related_date"
            class="form-label-group-label shorter"
            :class="
              fm1_main.fm1_main_related_date != '' &&
              fm1_main.fm1_main_related_date != null
                ? 'topped'
                : ''
            "
            >{{ $t("message.contracts.fm1_main_related_date") }}</label
          >
        </span>
        <span
          :class="['bmd-form-group mb-2 d-block form-label-group']"
          v-if="
            typeof fm1_main.fm1_main_form_state !== 'undefined' &&
            fm1_main.fm1_main_form_state.value == 2
          "
        >
          <!-- <b-form-datepicker :locale="locale" v-model="fm1_main.fm1_main_related_date" :placeholder="$t('message.contracts.fm1_main_form_state_2_date')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" id="fm1_main_form_state_2_date"></b-form-datepicker>
					<label  v-if="fm1_main.fm1_main_form_state!=''"  for="fm1_main_form_state" class="form-label-group-label shorter topped">{{$t('message.contracts.fm1_main_form_state')}}</label> -->

          <datepicker
            value-type="YYYY-MM-DD"
            format="DD.MM.YYYY"
            @focus="fm1_main.fm1_main_related_date = ' '"
            @blur="
              fm1_main.fm1_main_related_date == ' '
                ? (fm1_main.fm1_main_related_date = '')
                : (fm1_main.fm1_main_related_date =
                    fm1_main.fm1_main_related_date)
            "
            inputClass="form-control"
            :disabled="is_field_readonly"
            v-model="fm1_main.fm1_main_related_date"
            :placeholder="$t('message.contracts.fm1_main_form_state')"
            :inputAttr="{ id: 'fm1_main_form_state' }"
          />
          <label
            for="fm1_main_form_state"
            class="form-label-group-label shorter"
            :class="
              fm1_main.fm1_main_related_date != '' &&
              fm1_main.fm1_main_related_date != null
                ? 'topped'
                : ''
            "
            >{{ $t("message.contracts.fm1_main_form_state") }}</label
          >
        </span>
        <span
          :class="['bmd-form-group mb-2 d-block form-label-group']"
          v-if="
            typeof fm1_main.fm1_main_form_state !== 'undefined' &&
            fm1_main.fm1_main_form_state.value == 3
          "
        >
          <!-- <b-form-datepicker :locale="locale" v-model="fm1_main.fm1_main_related_date" :placeholder="$t('message.contracts.fm1_main_form_state_3_date')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" id="fm1_main_form_state_3_date"></b-form-datepicker>
					<label  v-if="fm1_main.fm1_main_form_state!=''"  for="fm1_main_form_state" class="form-label-group-label shorter topped">{{$t('message.contracts.fm1_main_form_state')}}</label> -->

          <datepicker
            value-type="YYYY-MM-DD"
            format="DD.MM.YYYY"
            @focus="fm1_main.fm1_main_form_state = ' '"
            @blur="
              fm1_main.fm1_main_form_state == ' '
                ? (fm1_main.fm1_main_form_state = '')
                : (fm1_main.fm1_main_form_state = fm1_main.fm1_main_form_state)
            "
            inputClass="form-control"
            :disabled="is_field_readonly"
            v-model="fm1_main.fm1_main_form_state"
            :placeholder="$t('message.contracts.fm1_main_form_state')"
            :inputAttr="{ id: 'fm1_main_form_state' }"
          />
          <label
            for="fm1_main_form_state"
            class="form-label-group-label shorter"
            :class="
              fm1_main.fm1_main_form_state != '' &&
              fm1_main.fm1_main_form_state != null
                ? 'topped'
                : ''
            "
            >{{ $t("message.contracts.fm1_main_form_state") }}</label
          >
        </span>
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group required',
            fm1_main_reason_focus ? 'focused' : '',
            $v.fm1_main.fm1_main_reason.$error ? 'has-danger' : '',
          ]"
        >
          <v-select
            :disabled="is_field_readonly"
            id="fm1_main_reason"
            :options="fm1_main_reasons"
            label="display_text"
            :class="[
              'form-control',
              typeof fm1_main.fm1_main_reason !== 'undefined' &&
              fm1_main.fm1_main_reason.value !== ''
                ? 'vs--selected'
                : '',
            ]"
            v-model="fm1_main.fm1_main_reason"
            :placeholder="$t('message.contracts.fm1_main_reason')"
            @focus="fm1_main_reason_Focused"
            @blur="fm1_main_reasonBlurred"
          ></v-select>
          <label for="fm1_main_reason" class="form-label-group-label shorter">{{
            $t("message.contracts.fm1_main_reason")
          }}</label>
          <label
            v-if="form_error && !$v.fm1_main.fm1_main_reason.required"
            class="control-label text-danger d-block"
            >{{ $t("message.errors.required") }}</label
          >
        </span>
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group',
            fm1_main_subreason_focus ? 'focused' : '',
          ]"
          v-if="
            typeof fm1_main.fm1_main_reason !== 'undefined' &&
            fm1_main.fm1_main_reason.value == 2
          "
        >
          <v-select
            :disabled="is_field_readonly"
            id="fm1_main_doc_kind"
            :options="fm1_main_subreasons"
            label="display_text"
            :class="[
              'form-control',
              typeof fm1_main.fm1_main_subreason !== 'undefined' &&
              fm1_main.fm1_main_subreason.value !== ''
                ? 'vs--selected'
                : '',
            ]"
            v-model="fm1_main.fm1_main_subreason"
            :placeholder="$t('message.contracts.fm1_main_subreason')"
            @focus="fm1_main_subreason_Focused"
            @blur="fm1_main_subreasonBlurred"
          ></v-select>
          <label
            for="fm1_main_doc_kind"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.fm1_main_subreason") }}</label
          >
        </span>
      </b-tab>
      <b-tab
        :title="$t('message.contracts.fm1_tab2_short')"
        :title-link-attributes="{ title: $t('message.contracts.fm1_tab2') }"
      >
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group required',
            $v.fm1_subject.fm1_subj_code.$error ? 'has-danger' : '',
          ]"
        >
          <cleave
            :disabled="is_field_readonly"
            v-model="fm1_subject.fm1_subj_code"
            :options="cleave_12_digits"
            class="form-control"
            :placeholder="$t('message.contracts.fm1_subj_code')"
            autocomplete="off"
            style="cursor: auto"
            id="fm1_subj_code"
          ></cleave>
          <label for="fm1_subj_code" class="form-label-group-label shorter">{{
            $t("message.contracts.fm1_subj_code")
          }}</label>
          <label
            v-if="form_error && !$v.fm1_subject.fm1_subj_code.required"
            class="control-label text-danger d-block"
            >{{ $t("message.errors.required") }}</label
          >
        </span>
        <h5>{{ $t("message.contracts.fm1_subj_group") }}</h5>
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group',
            fm1_subj_org_form_focus ? 'focused' : '',
          ]"
        >
          <v-select
            :disabled="is_field_readonly"
            id="fm1_subj_org_form"
            :options="org_forms"
            label="display_text"
            :class="[
              'form-control',
              typeof fm1_subject.fm1_subj_org_form !== 'undefined' &&
              fm1_subject.fm1_subj_org_form.value !== ''
                ? 'vs--selected'
                : '',
            ]"
            v-model="fm1_subject.fm1_subj_org_form"
            :placeholder="$t('message.contracts.fm1_subj_org_form')"
            @search="fetchorg_form"
            @focus="fm1_subj_org_form_Focused"
            @blur="fm1_subj_org_formBlurred"
          ></v-select>
          <label
            for="fm1_subj_org_form"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.fm1_subj_org_form") }}</label
          >
        </span>
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group required',
            $v.fm1_subject.fm1_subj_name.$error ? 'has-danger' : '',
          ]"
        >
          <input
            :disabled="is_field_readonly"
            type="text"
            class="form-control"
            v-model="fm1_subject.fm1_subj_name"
            :placeholder="$t('message.contracts.fm1_subj_name')"
            autocomplete="off"
            style="cursor: auto"
            id="fm1_subj_name"
          />
          <label for="fm1_subj_name" class="form-label-group-label shorter">{{
            $t("message.contracts.fm1_subj_name")
          }}</label>
          <label
            v-if="form_error && !$v.fm1_subject.fm1_subj_name.required"
            class="control-label text-danger d-block"
            >{{ $t("message.errors.required") }}</label
          >
        </span>
        <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
          <input
            :disabled="is_field_readonly"
            type="text"
            class="form-control"
            v-model="fm1_subject.fm1_subj_pers_second_name"
            :placeholder="$t('message.contracts.fm1_subj_pers_second_name')"
            autocomplete="off"
            style="cursor: auto"
            id="fm1_subj_pers_second_name"
          />
          <label
            for="fm1_subj_pers_second_name"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.fm1_subj_pers_second_name") }}</label
          >
        </span>
        <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
          <input
            :disabled="is_field_readonly"
            type="text"
            class="form-control"
            v-model="fm1_subject.fm1_subj_pers_name"
            :placeholder="$t('message.contracts.fm1_subj_pers_name')"
            autocomplete="off"
            style="cursor: auto"
            id="fm1_subj_pers_name"
          />
          <label
            for="fm1_subj_pers_name"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.fm1_subj_pers_name") }}</label
          >
        </span>
        <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
          <input
            :disabled="is_field_readonly"
            type="text"
            class="form-control"
            v-model="fm1_subject.fm1_subj_pers_middle_name"
            :placeholder="$t('message.contracts.fm1_subj_pers_patronymic')"
            autocomplete="off"
            style="cursor: auto"
            id="fm1_subj_pers_patronymic"
          />
          <label
            for="fm1_subj_pers_patronymic"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.fm1_subj_pers_patronymic") }}</label
          >
        </span>
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group required',
            $v.fm1_subject.fm1_subj_rnn.$error ? 'has-danger' : '',
          ]"
        >
          <input
            :disabled="is_field_readonly"
            type="text"
            class="form-control"
            v-model="fm1_subject.fm1_subj_rnn"
            :placeholder="$t('message.contracts.fm1_subj_rnn')"
            autocomplete="off"
            style="cursor: auto"
            id="fm1_subj_rnn"
          />
          <label for="fm1_subj_rnn" class="form-label-group-label shorter">{{
            $t("message.contracts.fm1_subj_rnn")
          }}</label>
          <label
            v-if="form_error && !$v.fm1_subject.fm1_subj_rnn.required"
            class="control-label text-danger d-block"
            >{{ $t("message.errors.required") }}</label
          >
        </span>
        <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
          <input
            :disabled="is_field_readonly"
            type="text"
            class="form-control"
            v-model="fm1_subject.fm1_subj_iin_bin"
            :placeholder="$t('message.contracts.fm1_subj_iin_bin')"
            autocomplete="off"
            style="cursor: auto"
            id="fm1_subj_iin_bin"
          />
          <label
            for="fm1_subj_iin_bin"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.fm1_subj_iin_bin") }}</label
          >
        </span>
        <h5>{{ $t("message.contracts.fm1_address_group") }}</h5>
        <div class="row">
          <div class="col-md-6">
            <span
              :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
            >
              <input
                :disabled="is_field_readonly"
                type="text"
                class="form-control"
                v-model="fm1_addrr.state_kaz"
                :placeholder="$t('message.contracts.state_kaz')"
                autocomplete="off"
                style="cursor: auto"
                id="state_kaz"
              />
              <label for="state_kaz" class="form-label-group-label shorter">{{
                $t("message.contracts.state_kaz")
              }}</label>
            </span>
          </div>
          <div class="col-md-6">
            <span
              :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
            >
              <input
                :disabled="is_field_readonly"
                type="text"
                class="form-control"
                v-model="fm1_addrr.region_kaz"
                :placeholder="$t('message.contracts.region_kaz')"
                autocomplete="off"
                style="cursor: auto"
                id="region_kaz"
              />
              <label for="region_kaz" class="form-label-group-label shorter">{{
                $t("message.contracts.region_kaz")
              }}</label>
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <span
              :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
            >
              <input
                :disabled="is_field_readonly"
                type="text"
                class="form-control"
                v-model="fm1_addrr.sity_kaz"
                :placeholder="$t('message.contracts.sity_kaz')"
                autocomplete="off"
                style="cursor: auto"
                id="sity_kaz"
              />
              <label
                for="sity_kaz"
                class="form-label-group-label shorter"
                style="white-space: pre-wrap"
                >{{ $t("message.contracts.sity_kaz") }}</label
              >
            </span>
          </div>
          <div class="col-md-6">
            <span
              :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
            >
              <input
                :disabled="is_field_readonly"
                type="text"
                class="form-control"
                v-model="fm1_addrr.street"
                :placeholder="$t('message.contracts.street')"
                autocomplete="off"
                style="cursor: auto"
                id="street"
              />
              <label for="street" class="form-label-group-label shorter">{{
                $t("message.contracts.street")
              }}</label>
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <span
              :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
            >
              <input
                :disabled="is_field_readonly"
                type="text"
                class="form-control"
                v-model="fm1_addrr.house_num"
                :placeholder="$t('message.contracts.house_num')"
                autocomplete="off"
                style="cursor: auto"
                id="house_num"
              />
              <label for="house_num" class="form-label-group-label shorter">{{
                $t("message.contracts.house_num")
              }}</label>
            </span>
          </div>
          <div class="col-md-4">
            <span
              :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
            >
              <input
                :disabled="is_field_readonly"
                type="text"
                class="form-control"
                v-model="fm1_addrr.flat_num"
                :placeholder="$t('message.contracts.flat_num')"
                autocomplete="off"
                style="cursor: auto"
                id="flat_num"
              />
              <label for="flat_num" class="form-label-group-label shorter">{{
                $t("message.contracts.flat_num")
              }}</label>
            </span>
          </div>
          <div class="col-md-4">
            <span
              :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
            >
              <input
                :disabled="is_field_readonly"
                type="text"
                class="form-control"
                v-model="fm1_addrr.post_index"
                :placeholder="$t('message.contracts.post_index')"
                autocomplete="off"
                style="cursor: auto"
                id="post_index"
              />
              <label for="post_index" class="form-label-group-label shorter">{{
                $t("message.contracts.post_index")
              }}</label>
            </span>
          </div>
        </div>
        <div
          id="subject_is_juridical"
          class="togglebutton other mt-md-3 form-label-group"
        >
          <label class="control-label-sm">
            <span>{{ $t("message.contracts.is_fiz_lico") }}</span
            ><br /><br />
            <input
              :disabled="is_field_readonly"
              type="checkbox"
              v-model="is_fiz_lico"
            />
            <span class="toggle"></span>
            <span class="choise_2">{{ $t("message.contracts.fiz_lico") }}</span>
            <span class="choise_1">{{ $t("message.contracts.yur_lico") }}</span>
          </label>
        </div>
        <div class="fiz_lico" v-if="is_fiz_lico">
          <h5>
            {{ $t("message.contracts.fm1_document_id_group") }}
          </h5>
          <h6>{{ $t("message.contracts.fm_1_passport_group") }}</h6>
          <div class="row">
            <div class="col-md-7">
              <span
                :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
              >
                <input
                  :disabled="is_field_readonly"
                  type="text"
                  class="form-control"
                  v-model="fm1_docs.doc_num"
                  :placeholder="$t('message.contracts.doc_num')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="doc_num"
                />
                <label for="doc_num" class="form-label-group-label shorter">{{
                  $t("message.contracts.doc_num")
                }}</label>
              </span>
            </div>
            <div class="col-md-5">
              <span
                :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
              >
                <input
                  :disabled="is_field_readonly"
                  type="text"
                  class="form-control"
                  v-model="fm1_docs.doc_series"
                  :placeholder="$t('message.contracts.doc_series')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="doc_series"
                />
                <label
                  for="doc_series"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.doc_series") }}</label
                >
              </span>
            </div>
          </div>
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              :disabled="is_field_readonly"
              type="text"
              class="form-control"
              v-model="fm1_docs.goverm_office"
              :placeholder="$t('message.contracts.goverm_office')"
              autocomplete="off"
              style="cursor: auto"
              id="goverm_office"
            />
            <label for="goverm_office" class="form-label-group-label shorter">{{
              $t("message.contracts.goverm_office")
            }}</label>
          </span>
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <!-- <b-form-datepicker :locale="locale" v-model="fm1_main.doc_date" :placeholder="$t('message.contracts.doc_date')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" id="doc_date"></b-form-datepicker>
						<label  v-if="fm1_main.doc_date!=''"  for="doc_date" class="form-label-group-label shorter topped">{{$t('message.contracts.doc_date')}}</label> -->

            <datepicker
              value-type="YYYY-MM-DD"
              format="DD.MM.YYYY"
              @focus="fm1_docs.doc_date = ' '"
              @blur="
                fm1_docs.doc_date == ' '
                  ? (fm1_docs.doc_date = '')
                  : (fm1_docs.doc_date = fm1_docs.doc_date)
              "
              inputClass="form-control"
              :disabled="is_field_readonly"
              v-model="fm1_docs.doc_date"
              :placeholder="$t('message.contracts.doc_date')"
              :inputAttr="{ id: 'doc_date' }"
            />
            <label
              for="doc_date"
              class="form-label-group-label shorter"
              :class="
                fm1_docs.doc_date != '' && fm1_docs.doc_date != null
                  ? 'topped'
                  : ''
              "
              >{{ $t("message.contracts.doc_date") }}</label
            >
          </span>
        </div>
        <h5>{{ $t("message.contracts.fm1_responsive_person_group") }}</h5>
        <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
          <input
            :disabled="is_field_readonly"
            type="text"
            class="form-control"
            v-model="fm1_subject.fm1_subj_manager_second_name"
            :placeholder="$t('message.contracts.fm1_subj_manager_second_name')"
            autocomplete="off"
            style="cursor: auto"
            id="fm1_subj_manager_second_name"
          />
          <label
            for="fm1_subj_manager_second_name"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.fm1_subj_manager_second_name") }}</label
          >
        </span>
        <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
          <input
            :disabled="is_field_readonly"
            type="text"
            class="form-control"
            v-model="fm1_subject.fm1_subj_manager_name"
            :placeholder="$t('message.contracts.fm1_subj_manager_name')"
            autocomplete="off"
            style="cursor: auto"
            id="fm1_subj_manager_name"
          />
          <label
            for="fm1_subj_manager_name"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.fm1_subj_manager_name") }}</label
          >
        </span>
        <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
          <input
            :disabled="is_field_readonly"
            type="text"
            class="form-control"
            v-model="fm1_subject.fm1_subj_manager_patronymic"
            :placeholder="$t('message.contracts.fm1_subj_manager_patronymic')"
            autocomplete="off"
            style="cursor: auto"
            id="fm1_subj_manager_patronymic"
          />
          <label
            for="fm1_subj_manager_patronymic"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.fm1_subj_manager_patronymic") }}</label
          >
        </span>
        <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
          <input
            :disabled="is_field_readonly"
            type="text"
            class="form-control"
            v-model="fm1_subject.fm1_subj_position"
            :placeholder="$t('message.contracts.fm1_subj_position')"
            autocomplete="off"
            style="cursor: auto"
            id="fm1_subj_position"
          />
          <label
            for="fm1_subj_position"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.fm1_subj_position") }}</label
          >
        </span>
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group required',
          ]"
        >
          <input
            :disabled="is_field_readonly"
            type="text"
            class="form-control"
            v-model="fm1_subject.fm1_subj_phone"
            :placeholder="$t('message.contracts.fm1_subj_phone')"
            autocomplete="off"
            style="cursor: auto"
            id="fm1_subj_phone"
          />
          <label for="fm1_subj_phone" class="form-label-group-label shorter">{{
            $t("message.contracts.fm1_subj_phone")
          }}</label>
          <label
            v-if="form_error && !$v.fm1_subject.fm1_subj_phone.required"
            class="control-label text-danger d-block"
            >{{ $t("message.errors.required") }}</label
          >
        </span>
        <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
          <input
            :disabled="is_field_readonly"
            type="email"
            class="form-control"
            v-model="fm1_subject.fm1_subj_email"
            :placeholder="$t('message.contracts.fm1_subj_email')"
            autocomplete="off"
            style="cursor: auto"
            id="fm1_subj_email"
          />
          <label for="fm1_subj_email" class="form-label-group-label shorter">{{
            $t("message.contracts.fm1_subj_email")
          }}</label>
        </span>
      </b-tab>
      <b-tab
        :title="$t('message.contracts.fm1_tab3_short')"
        :title-link-attributes="{ title: $t('message.contracts.fm1_tab3') }"
      >
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group required',
            $v.fm1_oper.fm1_oper_number.$error ? 'has-danger' : '',
          ]"
        >
          <cleave
            :disabled="is_field_readonly"
            v-model="fm1_oper.fm1_oper_number"
            :options="cleave_12_digits"
            class="form-control"
            :placeholder="$t('message.contracts.fm1_oper_number')"
            autocomplete="off"
            style="cursor: auto"
            id="fm1_oper_number"
          ></cleave>
          <label for="fm1_oper_number" class="form-label-group-label shorter">{{
            $t("message.contracts.fm1_oper_number")
          }}</label>
          <label
            v-if="form_error && !$v.fm1_oper.fm1_oper_number.required"
            class="control-label text-danger d-block"
            >{{ $t("message.errors.required") }}</label
          >
        </span>
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group required',
            fm1_oper_code_type_focus ? 'focused' : '',
            $v.fm1_oper.fm1_oper_code_type.$error ? 'has-danger' : '',
          ]"
        >
          <v-select
            :disabled="is_field_readonly"
            id="fm1_oper_code_type"
            :options="code_types"
            label="display_text"
            :class="[
              'form-control',
              typeof fm1_oper.fm1_oper_code_type !== 'undefined' &&
              fm1_oper.fm1_oper_code_type.value !== ''
                ? 'vs--selected'
                : '',
            ]"
            @search="fetchFm1CodeType"
            v-model="fm1_oper.fm1_oper_code_type"
            :placeholder="$t('message.contracts.fm1_oper_code_type')"
            @focus="fm1_oper_code_type_Focused"
            @blur="fm1_oper_code_typeBlurred"
          ></v-select>
          <label
            for="fm1_oper_code_type"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.fm1_oper_code_type") }}</label
          >
          <label
            v-if="form_error && !$v.fm1_oper.fm1_oper_code_type.required"
            class="control-label text-danger d-block"
            >{{ $t("message.errors.required") }}</label
          >
        </span>
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group required',
            fm1_oper_eknp_focus ? 'focused' : '',
            $v.fm1_oper.fm1_oper_eknp.$error ? 'has-danger' : '',
          ]"
        >
          <v-select
            :disabled="is_field_readonly"
            id="fm1_oper_eknp"
            :options="code_eknps"
            label="display_text"
            :class="[
              'form-control',
              typeof fm1_oper.fm1_oper_eknp !== 'undefined' &&
              fm1_oper.fm1_oper_eknp.value !== ''
                ? 'vs--selected'
                : '',
            ]"
            @search="fetchFm1CodeEknp"
            v-model="fm1_oper.fm1_oper_eknp"
            :placeholder="$t('message.contracts.fm1_oper_eknp')"
            @focus="fm1_oper_eknp_Focused"
            @blur="fm1_oper_eknpBlurred"
          ></v-select>
          <label for="fm1_oper_eknp" class="form-label-group-label shorter">{{
            $t("message.contracts.fm1_oper_eknp")
          }}</label>
          <label
            v-if="form_error && !$v.fm1_oper.fm1_oper_eknp.required"
            class="control-label text-danger d-block"
            >{{ $t("message.errors.required") }}</label
          >
        </span>
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group required',
            $v.fm1_oper.fm1_oper_members_quant.$error ? 'has-danger' : '',
          ]"
        >
          <input
            :disabled="is_field_readonly"
            type="text"
            class="form-control"
            v-model="fm1_oper.fm1_oper_members_quant"
            :placeholder="$t('message.contracts.fm1_oper_members_quant')"
            autocomplete="off"
            style="cursor: auto"
            id="fm1_oper_members_quant"
          />
          <label
            for="fm1_oper_members_quant"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.fm1_oper_members_quant") }}</label
          >
          <label
            v-if="form_error && !$v.fm1_oper.fm1_oper_members_quant.required"
            class="control-label text-danger d-block"
            >{{ $t("message.errors.required") }}</label
          >
        </span>
        <div class="row">
          <div class="col-md-12">
            <span
              :class="[
                'bmd-form-group mb-2 mt-2 d-block form-label-group required',
                fm1_oper_currency_focus ? 'focused' : '',
                $v.fm1_oper.fm1_oper_currency.$error ? 'has-danger' : '',
              ]"
            >
              <v-select
                :disabled="is_field_readonly"
                id="fm1_oper_currency"
                :options="currencies"
                label="display_text"
                :class="[
                  'form-control',
                  typeof fm1_oper.fm1_oper_currency !== 'undefined' &&
                  fm1_oper.fm1_oper_currency.value !== ''
                    ? 'vs--selected'
                    : '',
                ]"
                @search="fetchCurrency"
                v-model="fm1_oper.fm1_oper_currency"
                :placeholder="$t('message.contracts.fm1_oper_currency')"
                @focus="fm1_oper_currency_Focused"
                @blur="fm1_oper_currencyBlurred"
              ></v-select>
              <label
                for="fm1_oper_currency"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.fm1_oper_currency") }}</label
              >
              <label
                v-if="form_error && !$v.fm1_oper.fm1_oper_currency.required"
                class="control-label text-danger d-block"
                >{{ $t("message.errors.required") }}</label
              >
            </span>
          </div>
          <div class="col-md-6">
            <span
              :class="[
                'bmd-form-group mb-2 mt-2 d-block form-label-group required',
                $v.fm1_oper.fm1_oper_curr_code.$error ? 'has-danger' : '',
              ]"
            >
              <cleave
                :disabled="is_field_readonly"
                v-model="fm1_oper.fm1_oper_curr_code"
                :options="cleavePrice"
                class="form-control"
                :placeholder="$t('message.contracts.fm1_oper_curr_code')"
                autocomplete="off"
                style="cursor: auto"
                id="fm1_oper_curr_code"
              ></cleave>
              <label
                for="fm1_oper_curr_code"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.fm1_oper_curr_code") }}</label
              >
              <label
                v-if="form_error && !$v.fm1_oper.fm1_oper_curr_code.required"
                class="control-label text-danger d-block"
                >{{ $t("message.errors.required") }}</label
              >
            </span>
          </div>
          <div class="col-md-6">
            <span
              :class="[
                'bmd-form-group mb-2 mt-2 d-block form-label-group required',
                $v.fm1_oper.fm1_oper_tenge_sum.$error ? 'has-danger' : '',
              ]"
            >
              <cleave
                :disabled="is_field_readonly"
                v-model="fm1_oper.fm1_oper_tenge_sum"
                :options="cleavePrice"
                class="form-control"
                :placeholder="$t('message.contracts.fm1_oper_tenge_sum')"
                autocomplete="off"
                style="cursor: auto"
                id="fm1_oper_tenge_sum"
              ></cleave>
              <label
                for="fm1_oper_tenge_sum"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.fm1_oper_tenge_sum") }}</label
              >
              <label
                v-if="form_error && !$v.fm1_oper.fm1_oper_tenge_sum.required"
                class="control-label text-danger d-block"
                >{{ $t("message.errors.required") }}</label
              >
            </span>
          </div>
        </div>
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group required',
            fm1_oper_basis_focus ? 'focused' : '',
            $v.fm1_oper.fm1_oper_basis.$error ? 'has-danger' : '',
          ]"
        >
          <v-select
            :disabled="is_field_readonly"
            id="fm1_oper_basis"
            :options="oper_basises"
            label="display_text"
            :class="[
              'form-control',
              typeof fm1_oper.fm1_oper_basis !== 'undefined' &&
              fm1_oper.fm1_oper_basis.value !== ''
                ? 'vs--selected'
                : '',
            ]"
            @search="fetchFm1OperBasis"
            v-model="fm1_oper.fm1_oper_basis"
            :placeholder="$t('message.contracts.fm1_oper_basis')"
            @focus="fm1_oper_basis_Focused"
            @blur="fm1_oper_basisBlurred"
          ></v-select>
          <label for="fm1_oper_basis" class="form-label-group-label shorter">{{
            $t("message.contracts.fm1_oper_basis")
          }}</label>
          <label
            v-if="form_error && !$v.fm1_oper.fm1_oper_basis.required"
            class="control-label text-danger d-block"
            >{{ $t("message.errors.required") }}</label
          >
        </span>
        <h5>{{ $t("message.contracts.fm1_oper_group") }}</h5>
        <div class="row">
          <div class="col-md-6">
            <span :class="['bmd-form-group mb-2 d-block form-label-group']">
              <!-- <b-form-datepicker :locale="locale" v-model="fm1_oper.fm1_oper_basis_doc_date" :placeholder="$t('message.contracts.fm1_oper_basis_doc_date')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" id="fm1_oper_basis_doc_date"></b-form-datepicker>
							<label  v-if="fm1_oper.fm1_oper_basis_doc_date!=''"  for="fm1_oper_basis_doc_date" class="form-label-group-label shorter topped">{{$t('message.contracts.fm1_oper_basis_doc_date')}}</label> -->

              <datepicker
                value-type="YYYY-MM-DD"
                format="DD.MM.YYYY"
                @focus="fm1_oper.fm1_oper_basis_doc_date = ' '"
                @blur="
                  fm1_oper.fm1_oper_basis_doc_date == ' '
                    ? (fm1_oper.fm1_oper_basis_doc_date = '')
                    : (fm1_oper.fm1_oper_basis_doc_date =
                        fm1_oper.fm1_oper_basis_doc_date)
                "
                inputClass="form-control"
                :disabled="is_field_readonly"
                v-model="fm1_oper.fm1_oper_basis_doc_date"
                :placeholder="$t('message.contracts.fm1_oper_basis_doc_date')"
                :inputAttr="{ id: 'fm1_oper_basis_doc_date' }"
              />
              <label
                for="fm1_oper_basis_doc_date"
                class="form-label-group-label shorter"
                :class="
                  fm1_oper.fm1_oper_basis_doc_date != '' &&
                  fm1_oper.fm1_oper_basis_doc_date != null
                    ? 'topped'
                    : ''
                "
                >{{ $t("message.contracts.fm1_oper_basis_doc_date") }}</label
              >
            </span>
          </div>
          <div class="col-md-6">
            <span
              :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
            >
              <input
                :disabled="is_field_readonly"
                type="text"
                class="form-control"
                v-model="fm1_oper.fm1_oper_basis_doc_num"
                :placeholder="$t('message.contracts.fm1_oper_basis_doc_num')"
                autocomplete="off"
                style="cursor: auto"
                id="fm1_oper_basis_doc_num"
              />
              <label
                for="fm1_oper_basis_doc_num"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.fm1_oper_basis_doc_num") }}</label
              >
            </span>
          </div>
        </div>
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group ',
            fm1_oper_1code_focus ? 'focused' : '',
          ]"
        >
          <v-select
            :disabled="is_field_readonly"
            id="fm1_oper_1code"
            :options="oper_codes"
            label="display_text"
            :class="[
              'form-control',
              typeof fm1_oper.fm1_oper_1code !== 'undefined' &&
              fm1_oper.fm1_oper_1code.value !== ''
                ? 'vs--selected'
                : '',
            ]"
            @search="fetchFm1OperCode"
            v-model="fm1_oper.fm1_oper_1code"
            :placeholder="$t('message.contracts.fm1_oper_1code')"
            @focus="fm1_oper_1code_Focused"
            @blur="fm1_oper_1codeBlurred"
          ></v-select>
          <label for="fm1_oper_1code" class="form-label-group-label shorter">{{
            $t("message.contracts.fm1_oper_1code")
          }}</label>
        </span>
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group ',
            fm1_oper_1code_focus ? 'focused' : '',
          ]"
        >
          <v-select
            :disabled="is_field_readonly"
            id="fm1_oper_2code"
            :options="oper_codes"
            label="display_text"
            :class="[
              'form-control',
              typeof fm1_oper.fm1_oper_2code !== 'undefined' &&
              fm1_oper.fm1_oper_2code.value !== ''
                ? 'vs--selected'
                : '',
            ]"
            @search="fetchFm1OperCode"
            v-model="fm1_oper.fm1_oper_2code"
            :placeholder="$t('message.contracts.fm1_oper_2code')"
            @focus="fm1_oper_2code_Focused"
            @blur="fm1_oper_2codeBlurred"
          ></v-select>
          <label for="fm1_oper_2code" class="form-label-group-label shorter">{{
            $t("message.contracts.fm1_oper_2code")
          }}</label>
        </span>
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group ',
            fm1_oper_1code_focus ? 'focused' : '',
          ]"
        >
          <v-select
            :disabled="is_field_readonly"
            id="fm1_oper_3code"
            :options="oper_codes"
            label="display_text"
            :class="[
              'form-control',
              typeof fm1_oper.fm1_oper_3code !== 'undefined' &&
              fm1_oper.fm1_oper_3code.value !== ''
                ? 'vs--selected'
                : '',
            ]"
            @search="fetchFm1OperCode"
            v-model="fm1_oper.fm1_oper_3code"
            :placeholder="$t('message.contracts.fm1_oper_3code')"
            @focus="fm1_oper_3code_Focused"
            @blur="fm1_oper_3codeBlurred"
          ></v-select>
          <label for="fm1_oper_3code" class="form-label-group-label shorter">{{
            $t("message.contracts.fm1_oper_3code")
          }}</label>
        </span>
        <translatable>
          <span
            :class="[
              'bmd-form-group mb-2 mt-2 d-block form-label-group required',
              $v.fm1_oper.fm1_oper_trouble_desc.$error ? 'has-danger' : '',
            ]"
          >
            <input
              :disabled="is_field_readonly"
              type="text"
              class="form-control"
              v-model="fm1_oper.fm1_oper_trouble_desc"
              :placeholder="$t('message.contracts.fm1_oper_trouble_desc')"
              autocomplete="off"
              style="cursor: auto"
              id="fm1_oper_trouble_desc"
            />
            <label
              for="fm1_oper_trouble_desc"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.fm1_oper_trouble_desc") }}</label
            >
            <label
              v-if="form_error && !$v.fm1_oper.fm1_oper_trouble_desc.required"
              class="control-label text-danger d-block"
              >{{ $t("message.errors.required") }}</label
            >
          </span>
        </translatable>
        <translatable>
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              :disabled="is_field_readonly"
              type="text"
              class="form-control"
              v-model="fm1_oper.fm1_oper_add_info"
              :placeholder="$t('message.contracts.fm1_oper_add_info')"
              autocomplete="off"
              style="cursor: auto"
              id="fm1_oper_add_info"
            />
            <label
              for="fm1_oper_add_info"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.fm1_oper_add_info") }}</label
            >
          </span>
        </translatable>
      </b-tab>
      <b-tab
        :title="$t('message.contracts.fm1_tab4_short')"
        :title-link-attributes="{ title: $t('message.contracts.fm1_tab4') }"
      >
        <h4>{{ $t("message.contracts.fm1_tab4_short") }}</h4>
        <b-table :items="fm1_members_list" :fields="fm1_members_fields">
          <template v-slot:cell(action)="data">
            <button
              v-if="!is_field_readonly"
              class="btn btn-link p-0 text-danger ml-2 float-right"
              @click="removeMember(data.index)"
            >
              <i class="fa fa-trash"></i>
            </button>
            <button
              class="btn btn-link p-0 float-right"
              @click="openMember(data.item)"
            >
              <i class="fa fa-edit"></i>
            </button>
          </template>
        </b-table>
        <div
          v-if="show_fm1_member"
          class="add-product-block alert-success-"
          style="margin: 0 -1.5em"
        >
          <span
            :class="[
              'bmd-form-group mb-2 mt-2 d-block required' /*$v.fm1_members.fm1_member.$error?'has-danger':''*/,
            ]"
          >
            <label class="form-label-group-label shorter">{{
              $t("message.contracts.fm1_members_fm1_member")
            }}</label>
            <label
              v-for="(row, rri) in fm1_members_members"
              class="d-block"
              :key="rri"
            >
              <input
                :disabled="is_field_readonly"
                type="radio"
                v-model="fm1_members.fm1_member"
                :value="row.value"
              />
              {{ row.display_text }}
            </label>
            <!-- <label v-if="form_error && !$v.fm1_members.fm1_member.required" class="control-label text-danger d-block">{{$t('message.errors.required')}}</label> -->
          </span>
          <div class="togglebutton other mt-md-3 form-label-group required">
            <label class="control-label-sm">
              <span>{{
                $t("message.contracts.fm1_members_fm1_memb_is_subj")
              }}</span
              ><br /><br />
              <input
                :disabled="is_field_readonly"
                type="checkbox"
                v-model="fm1_members.fm1_memb_is_subj"
              />
              <span class="toggle"></span>
              <span class="choise_2">{{
                $t("message.contracts.fm1_memebers_memb_subj_is")
              }}</span>
              <span class="choise_1">{{
                $t("message.contracts.fm1_memebers_memb_subj_is_not")
              }}</span>
            </label>
          </div>
          <span
            :class="[
              'bmd-form-group mb-2 mt-2 d-block form-label-group required',
              fm1_memb_subj_kind_focus
                ? 'focused'
                : '' /*$v.fm1_members.fm1_memb_subj_kind.$error?'has-danger':''*/,
            ]"
          >
            <v-select
              :disabled="is_field_readonly"
              id="fm1_oper_1code"
              :options="fm1_memb_subj_kinds"
              label="display_text"
              :class="[
                'form-control',
                typeof fm1_members.fm1_memb_subj_kind !== 'undefined' &&
                fm1_members.fm1_memb_subj_kind.value !== ''
                  ? 'vs--selected'
                  : '',
              ]"
              @search="fetchMembSubjKind"
              v-model="fm1_members.fm1_memb_subj_kind"
              :placeholder="$t('message.contracts.fm1_memb_subj_kind')"
              @focus="fm1_memb_subj_kind_Focused"
              @blur="fm1_memb_subj_kindBlurred"
            ></v-select>
            <label
              for="fm1_memb_subj_kind"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.fm1_members_fm1_memb_subj_kind")
              }}</label
            >
            <!-- <label v-if="form_error && !$v.fm1_members.fm1_memb_subj_kind.required" class="control-label text-danger d-block">{{$t('message.errors.required')}}</label> -->
          </span>
          <span
            :class="[
              'bmd-form-group mb-2 mt-2 d-block form-label-group',
              fm1_memb_country_focus ? 'focused' : '',
            ]"
          >
            <v-select
              :disabled="is_field_readonly"
              id="fm1_oper_1code"
              :options="countries"
              label="display_text"
              :class="[
                'form-control',
                typeof fm1_members.fm1_memb_country !== 'undefined' &&
                fm1_members.fm1_memb_country.value !== ''
                  ? 'vs--selected'
                  : '',
              ]"
              @search="fetchCountries"
              v-model="fm1_members.fm1_memb_country"
              :placeholder="$t('message.contracts.fm1_memb_country')"
              @focus="fm1_memb_country_Focused"
              @blur="fm1_memb_countryBlurred"
            ></v-select>
            <label
              for="fm1_memb_country"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.fm1_members_fm1_memb_country") }}</label
            >
          </span>
          <span
            :class="[
              'bmd-form-group mb-2 mt-2 d-block required' /*$v.fm1_members.fm1_memb_type.$error?'has-danger':''*/,
            ]"
          >
            <label class="form-label-group-label shorter">{{
              $t("message.contracts.fm1_members_fm1_memb_type")
            }}</label>
            <label
              v-for="(row, rt) in fm1_memb_types"
              class="d-block"
              :key="rt"
            >
              <input
                :disabled="is_field_readonly"
                type="radio"
                v-model="fm1_members.fm1_memb_type"
                :value="row.value"
              />
              {{ row.display_text }}
            </label>
            <!-- <label v-if="form_error && !$v.fm1_members.fm1_memb_type.required" class="control-label text-danger d-block">{{$t('message.errors.required')}}</label> -->
          </span>
          <span :class="['bmd-form-group mb-2 mt-2 d-block']">
            <label class="form-label-group-label shorter">{{
              $t("message.contracts.fm1_members_fm1_memb_foreign")
            }}</label>
            <label
              v-for="(row, yy) in fm1_memb_foreigns"
              class="d-block"
              :key="yy"
            >
              <input
                :disabled="is_field_readonly"
                type="radio"
                v-model="fm1_members.fm1_memb_foreign"
                :value="row.value"
              />
              {{ row.display_text }}
            </label>
          </span>
          <h4 class="text-dark">
            {{ $t("message.contracts.fm1_member_bank") }}
          </h4>
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              :disabled="is_field_readonly"
              type="text"
              class="form-control"
              v-model="fm1_members.fm1_memb_bank_branch_place"
              :placeholder="
                $t('message.contracts.fm1_members_fm1_memb_bank_branch_place')
              "
              autocomplete="off"
              style="cursor: auto"
              id="fm1_memb_bank_branch_place"
            />
            <label
              for="fm1_memb_bank_branch_place"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.fm1_members_fm1_memb_bank_branch_place")
              }}</label
            >
          </span>
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              :disabled="is_field_readonly"
              type="text"
              class="form-control"
              v-model="fm1_members.fm1_memb_bank_branch"
              :placeholder="
                $t('message.contracts.fm1_members_fm1_memb_bank_branch')
              "
              autocomplete="off"
              style="cursor: auto"
              id="fm1_memb_bank_branch"
            />
            <label
              for="fm1_memb_bank_branch"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.fm1_members_fm1_memb_bank_branch")
              }}</label
            >
          </span>
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              :disabled="is_field_readonly"
              type="text"
              class="form-control"
              v-model="fm1_members.fm1_memb_sdp"
              :placeholder="$t('message.contracts.fm1_members_fm1_memb_sdp')"
              autocomplete="off"
              style="cursor: auto"
              id="fm1_memb_sdp"
            />
            <label for="fm1_memb_sdp" class="form-label-group-label shorter">{{
              $t("message.contracts.fm1_members_fm1_memb_sdp")
            }}</label>
          </span>
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              :disabled="is_field_readonly"
              type="text"
              class="form-control"
              v-model="fm1_members.fm1_memb_branch_code"
              :placeholder="
                $t('message.contracts.fm1_members_fm1_memb_branch_code')
              "
              autocomplete="off"
              style="cursor: auto"
              id="fm1_memb_branch_code"
            />
            <label
              for="fm1_memb_branch_code"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.fm1_members_fm1_memb_branch_code")
              }}</label
            >
          </span>
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              :disabled="is_field_readonly"
              type="text"
              class="form-control"
              v-model="fm1_members.fm1_memb_acc"
              :placeholder="$t('message.contracts.fm1_members_fm1_memb_acc')"
              autocomplete="off"
              style="cursor: auto"
              id="fm1_memb_acc"
            />
            <label for="fm1_memb_acc" class="form-label-group-label shorter">{{
              $t("message.contracts.fm1_members_fm1_memb_acc")
            }}</label>
          </span>
          <h4 class="text-dark">
            {{ $t("message.contracts.fm1_correspondent_account") }}
          </h4>
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              :disabled="is_field_readonly"
              type="text"
              class="form-control"
              v-model="fm1_members.fm1_memb_bank_place"
              :placeholder="
                $t('message.contracts.fm1_members_fm1_memb_bank_place')
              "
              autocomplete="off"
              style="cursor: auto"
              id="fm1_memb_bank_place"
            />
            <label
              for="fm1_memb_bank_place"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.fm1_members_fm1_memb_bank_place")
              }}</label
            >
          </span>
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              :disabled="is_field_readonly"
              type="text"
              class="form-control"
              v-model="fm1_members.fm1_memb_bank_name"
              :placeholder="
                $t('message.contracts.fm1_members_fm1_memb_bank_name')
              "
              autocomplete="off"
              style="cursor: auto"
              id="fm1_memb_bank_name"
            />
            <label
              for="fm1_memb_bank_name"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.fm1_members_fm1_memb_bank_name")
              }}</label
            >
          </span>
          <h4 class="text-dark">
            {{ $t("message.contracts.fm1_name_of_participant") }}
          </h4>
          <h4 class="text-dark">
            {{ $t("message.contracts.fm1_member_participant") }}
          </h4>
          <span
            :class="[
              'bmd-form-group mb-2 mt-2 d-block form-label-group',
              fm1_memb_org_form_focus ? 'focused' : '',
            ]"
          >
            <v-select
              :disabled="is_field_readonly"
              id="fm1_memb_org_form"
              :options="fm1_memb_org_forms"
              label="display_text"
              :class="[
                'form-control',
                typeof fm1_members.fm1_memb_org_form !== 'undefined' &&
                fm1_members.fm1_memb_org_form.value !== ''
                  ? 'vs--selected'
                  : '',
              ]"
              v-model="fm1_members.fm1_memb_org_form"
              :placeholder="
                $t('message.contracts.fm1_members_fm1_memb_org_form')
              "
              @focus="fm1_memb_org_form_Focused"
              @blur="fm1_memb_org_formBlurred"
            ></v-select>
            <label
              for="fm1_memb_org_form"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.fm1_members_fm1_memb_org_form")
              }}</label
            >
          </span>
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              :disabled="is_field_readonly"
              type="text"
              class="form-control"
              v-model="fm1_members.fm1_memb_company_name"
              :placeholder="
                $t('message.contracts.fm1_members_fm1_memb_company_name')
              "
              autocomplete="off"
              style="cursor: auto"
              id="fm1_memb_company_name"
            />
            <label
              for="fm1_memb_company_name"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.fm1_members_fm1_memb_company_name")
              }}</label
            >
            <label
              >{{ $t("message.contracts.fm1_members_fm1_memb_noname") }}
              <input type="checkbox" v-model="fm1_members.fm1_memb_noname"
            /></label>
          </span>
          <h4 class="text-dark">
            {{ $t("message.contracts.fm1_founders_of_member") }}
          </h4>
          <span
            :class="[
              'bmd-form-group mb-2 mt-2 d-block form-label-group',
              fm1_memb_founder_org_form_focus ? 'focused' : '',
            ]"
          >
            <v-select
              :disabled="is_field_readonly"
              id="fm1_memb_founder_org_form"
              :options="fm1_memb_org_forms"
              label="display_text"
              :class="[
                'form-control',
                typeof fm1_members.fm1_memb_founder_org_form !== 'undefined' &&
                fm1_members.fm1_memb_founder_org_form.value !== ''
                  ? 'vs--selected'
                  : '',
              ]"
              v-model="fm1_members.fm1_memb_founder_org_form"
              :placeholder="
                $t('message.contracts.fm1_members_fm1_memb_founder_org_form')
              "
              @focus="fm1_memb_founder_org_form_Focused"
              @blur="fm1_memb_founder_org_formBlurred"
            ></v-select>
            <label
              for="fm1_memb_founder_org_form"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.fm1_members_fm1_memb_founder_org_form")
              }}</label
            >
          </span>
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              :disabled="is_field_readonly"
              type="text"
              class="form-control"
              v-model="fm1_members.fm1_memb_founder_"
              :placeholder="
                $t('message.contracts.fm1_members_fm1_memb_founder_')
              "
              autocomplete="off"
              style="cursor: auto"
              id="fm1_memb_founder_"
            />
            <label
              for="fm1_memb_founder_"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.fm1_members_fm1_memb_founder_")
              }}</label
            >
          </span>
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              :disabled="is_field_readonly"
              type="text"
              class="form-control"
              v-model="fm1_members.fm1_memb_founder_secondname"
              :placeholder="
                $t('message.contracts.fm1_members_fm1_memb_founder_secondname')
              "
              autocomplete="off"
              style="cursor: auto"
              id="fm1_memb_founder_secondname"
            />
            <label
              for="fm1_memb_founder_secondname"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.fm1_members_fm1_memb_founder_secondname")
              }}</label
            >
          </span>
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              :disabled="is_field_readonly"
              type="text"
              class="form-control"
              v-model="fm1_members.fm1_memb_founder_name"
              :placeholder="
                $t('message.contracts.fm1_members_fm1_memb_founder_name')
              "
              autocomplete="off"
              style="cursor: auto"
              id="fm1_memb_founder_name"
            />
            <label
              for="fm1_memb_founder_name"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.fm1_members_fm1_memb_founder_name")
              }}</label
            >
          </span>
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              :disabled="is_field_readonly"
              type="text"
              class="form-control"
              v-model="fm1_members.fm1_memb_founder_patronymic"
              :placeholder="
                $t('message.contracts.fm1_members_fm1_memb_founder_patronymic')
              "
              autocomplete="off"
              style="cursor: auto"
              id="fm1_memb_founder_patronymic"
            />
            <label
              for="fm1_memb_founder_patronymic"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.fm1_members_fm1_memb_founder_patronymic")
              }}</label
            >
          </span>
          <span
            :class="[
              'bmd-form-group mb-2 mt-2 d-block form-label-group',
              fm1_memb_country2_focus ? 'focused' : '',
            ]"
          >
            <v-select
              :disabled="is_field_readonly"
              id="fm1_memb_country_2"
              :options="countries"
              label="display_text"
              :class="[
                'form-control',
                typeof fm1_members.fm1_memb_country_2 !== 'undefined' &&
                fm1_members.fm1_memb_country_2.value !== ''
                  ? 'vs--selected'
                  : '',
              ]"
              @search="fetchCountries"
              v-model="fm1_members.fm1_memb_country_2"
              :placeholder="$t('message.contracts.fm1_memb_country')"
              @focus="fm1_memb_country2_Focused"
              @blur="fm1_memb_country2Blurred"
            ></v-select>
            <label
              for="fm1_memb_country_2"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.fm1_members_fm1_memb_country") }}</label
            >
          </span>

          <h4 class="text-dark">
            {{ $t("message.contracts.fm1_first_head") }}
          </h4>
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              :disabled="is_field_readonly"
              type="text"
              class="form-control"
              v-model="fm1_members.fm1_person_secondname"
              :placeholder="
                $t('message.contracts.fm1_persons_fm1_person_secondname')
              "
              autocomplete="off"
              style="cursor: auto"
              id="fm1_person_secondname"
            />
            <label
              for="fm1_person_secondname"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.fm1_persons_fm1_person_secondname")
              }}</label
            >
          </span>
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              :disabled="is_field_readonly"
              type="text"
              class="form-control"
              v-model="fm1_members.fm1_person_name"
              :placeholder="$t('message.contracts.fm1_persons_fm1_person_name')"
              autocomplete="off"
              style="cursor: auto"
              id="fm1_person_name"
            />
            <label
              for="fm1_person_name"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.fm1_persons_fm1_person_name") }}</label
            >
          </span>
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              :disabled="is_field_readonly"
              type="text"
              class="form-control"
              v-model="fm1_members.fm1_person_midle_name"
              :placeholder="
                $t('message.contracts.fm1_persons_fm1_person_midle_name')
              "
              autocomplete="off"
              style="cursor: auto"
              id="fm1_person_midle_name"
            />
            <label
              for="fm1_person_midle_name"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.fm1_persons_fm1_person_midle_name")
              }}</label
            >
          </span>
          <span
            :class="[
              'bmd-form-group mb-2 d-block form-label-group',
              oked_focused ? 'focused' : '',
            ]"
          >
            <v-select
              :disabled="is_field_readonly"
              :options="okeds"
              label="display_text"
              :class="[
                'form-control',
                typeof fm1_members.oked !== 'undefined' &&
                fm1_members.oked.value !== ''
                  ? 'vs--selected'
                  : '',
              ]"
              @search="fetchOkeds"
              v-model="fm1_members.oked"
              :placeholder="$t('message.contracts.fm1_members_oked')"
              @focus="okedsFocused"
              @blur="okedsBlurred"
            ></v-select>
            <label for="company_oked" class="form-label-group-label shorter">{{
              $t("message.contracts.fm1_members_oked")
            }}</label>
          </span>
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <cleave
              :disabled="is_field_readonly"
              v-model="fm1_members.iin_bin"
              :options="cleave_12_digits"
              class="form-control"
              :placeholder="$t('message.contracts.fm1_members_iin_bin')"
              autocomplete="off"
              style="cursor: auto"
              id="iin_bin"
            ></cleave>
            <label for="iin_bin" class="form-label-group-label shorter">{{
              $t("message.contracts.fm1_members_iin_bin")
            }}</label>
          </span>
          <h4 class="text-dark">
            {{ $t("message.contracts.fm1_memebers_fio") }}
          </h4>
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              :disabled="is_field_readonly"
              type="text"
              class="form-control"
              v-model="fm1_members.fm1_person_secondname_2"
              :placeholder="
                $t('message.contracts.fm1_persons_fm1_person_secondname')
              "
              autocomplete="off"
              style="cursor: auto"
              id="fm1_person_secondname1"
            />
            <label
              for="fm1_person_secondname1"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.fm1_persons_fm1_person_secondname")
              }}</label
            >
          </span>
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              :disabled="is_field_readonly"
              type="text"
              class="form-control"
              v-model="fm1_members.fm1_person_name_2"
              :placeholder="$t('message.contracts.fm1_persons_fm1_person_name')"
              autocomplete="off"
              style="cursor: auto"
              id="fm1_person_name1"
            />
            <label
              for="fm1_person_name1"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.fm1_persons_fm1_person_name") }}</label
            >
          </span>
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              :disabled="is_field_readonly"
              type="text"
              class="form-control"
              v-model="fm1_members.fm1_person_middle_name_2"
              :placeholder="
                $t('message.contracts.fm1_persons_fm1_person_midle_name')
              "
              autocomplete="off"
              style="cursor: auto"
              id="fm1_person_middle_name_2"
            />
            <label
              for="fm1_person_middle_name_2"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.fm1_persons_fm1_person_midle_name")
              }}</label
            >
          </span>
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              :disabled="is_field_readonly"
              type="text"
              class="form-control"
              v-model="fm1_members.doc_type_2"
              :placeholder="$t('message.contracts.fm1_docs_doc_type')"
              autocomplete="off"
              style="cursor: auto"
              id="fm1_docs_doc_type1"
            />
            <label
              for="fm1_docs_doc_type1"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.fm1_docs_doc_type") }}</label
            >
          </span>
          <h4 class="text-dark">
            {{ $t("message.contracts.fm1_docs_doc_type_first_head") }}
          </h4>
          <div class="row">
            <div class="col-6">
              <span
                :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
              >
                <input
                  :disabled="is_field_readonly"
                  type="text"
                  class="form-control"
                  v-model="fm1_members.doc_num_2"
                  :placeholder="$t('message.contracts.fm1_docs_doc_num')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="fm1_docs_doc_num"
                />
                <label
                  for="fm1_docs_doc_num"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.fm1_docs_doc_num") }}</label
                >
              </span>
            </div>
            <div class="col-6">
              <span
                :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
              >
                <input
                  :disabled="is_field_readonly"
                  type="text"
                  class="form-control"
                  v-model="fm1_members.doc_series_2"
                  :placeholder="$t('message.contracts.fm1_docs_doc_series')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="fm1_docs_doc_series"
                />
                <label
                  for="fm1_docs_doc_series"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.fm1_docs_doc_series") }}</label
                >
              </span>
            </div>
          </div>
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              :disabled="is_field_readonly"
              type="text"
              class="form-control"
              v-model="fm1_members.goverm_office_2"
              :placeholder="$t('message.contracts.fm1_docs_goverm_office')"
              autocomplete="off"
              style="cursor: auto"
              id="fm1_docs_goverm_office"
            />
            <label
              for="fm1_docs_goverm_office"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.fm1_docs_goverm_office") }}</label
            >
          </span>
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <datepicker
              value-type="YYYY-MM-DD"
              format="DD.MM.YYYY"
              @focus="fm1_members.doc_date_2 = ' '"
              @blur="
                fm1_members.doc_date_2 == ' '
                  ? (fm1_members.doc_date_2 = '')
                  : (fm1_members.doc_date_2 = fm1_members.doc_date_2)
              "
              inputClass="form-control"
              :disabled="is_field_readonly"
              v-model="fm1_members.doc_date_2"
              :placeholder="$t('message.contracts.fm1_docs_doc_date')"
              :inputAttr="{ id: 'fm1_docs2_doc_date' }"
            />
            <label
              for="fm1_docs2_doc_date"
              class="form-label-group-label shorter"
              :class="
                fm1_members.doc_date != '' && fm1_members.doc_date != null
                  ? 'topped'
                  : ''
              "
              >{{ $t("message.contracts.fm1_docs_doc_date") }}</label
            >
          </span>
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <datepicker
              value-type="YYYY-MM-DD"
              format="DD.MM.YYYY"
              @focus="fm1_members.fm1_person_birth_date = ' '"
              @blur="
                fm1_members.fm1_person_birth_date == ' '
                  ? (fm1_members.fm1_person_birth_date = '')
                  : (fm1_members.fm1_person_birth_date =
                      fm1_members.fm1_person_birth_date)
              "
              inputClass="form-control"
              :disabled="is_field_readonly"
              v-model="fm1_members.fm1_person_birth_date"
              :placeholder="
                $t('message.contracts.fm1_persons_fm1_person_birth_date')
              "
              :inputAttr="{ id: 'fm1_persons_fm1_person_birth_date' }"
            />
            <label
              for="fm1_persons_fm1_person_birth_date"
              class="form-label-group-label shorter"
              :class="
                fm1_members.fm1_person_birth_date != '' &&
                fm1_members.fm1_person_birth_date != null
                  ? 'topped'
                  : ''
              "
              >{{
                $t("message.contracts.fm1_persons_fm1_person_birth_date")
              }}</label
            >
          </span>
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              :disabled="is_field_readonly"
              type="text"
              class="form-control"
              v-model="fm1_members.fm1_person_birth_place"
              :placeholder="
                $t('message.contracts.fm1_persons_fm1_person_birth_place')
              "
              autocomplete="off"
              style="cursor: auto"
              id="fm1_persons_fm1_person_birth_place"
            />
            <label
              for="fm1_persons_fm1_person_birth_place"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.fm1_persons_fm1_person_birth_place")
              }}</label
            >
          </span>
          <h4 class="text-dark">
            {{ $t("message.contracts.fm1_persons_yur_address") }}
          </h4>
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              :disabled="is_field_readonly"
              type="text"
              class="form-control"
              v-model="fm1_members.state_kaz_2"
              :placeholder="$t('message.contracts.fm1_addrr_state_kaz')"
              autocomplete="off"
              style="cursor: auto"
              id="fm1_addrr_state_kaz"
            />
            <label
              for="fm1_addrr_state_kaz"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.fm1_addrr_state_kaz") }}</label
            >
          </span>
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              :disabled="is_field_readonly"
              type="text"
              class="form-control"
              v-model="fm1_members.region_kaz_2"
              :placeholder="$t('message.contracts.fm1_addrr_region_kaz')"
              autocomplete="off"
              style="cursor: auto"
              id="fm1_addrr_region_kaz"
            />
            <label
              for="fm1_addrr_region_kaz"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.fm1_addrr_region_kaz") }}</label
            >
          </span>
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              :disabled="is_field_readonly"
              type="text"
              class="form-control"
              v-model="fm1_members.sity_kaz_2"
              :placeholder="$t('message.contracts.fm1_addrr_sity_kaz')"
              autocomplete="off"
              style="cursor: auto"
              id="fm1_addrr_sity_kaz"
            />
            <label
              for="fm1_addrr_sity_kaz"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.fm1_addrr_sity_kaz") }}</label
            >
          </span>
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              :disabled="is_field_readonly"
              type="text"
              class="form-control"
              v-model="fm1_members.street_2"
              :placeholder="$t('message.contracts.fm1_addrr_street')"
              autocomplete="off"
              style="cursor: auto"
              id="fm1_addrr_street"
            />
            <label
              for="fm1_addrr_street"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.fm1_addrr_street") }}</label
            >
          </span>
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              :disabled="is_field_readonly"
              type="text"
              class="form-control"
              v-model="fm1_members.house_num_2"
              :placeholder="$t('message.contracts.fm1_addrr_house_num')"
              autocomplete="off"
              style="cursor: auto"
              id="fm1_addrr_house_num"
            />
            <label
              for="fm1_addrr_house_num"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.fm1_addrr_house_num") }}</label
            >
          </span>
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              :disabled="is_field_readonly"
              type="text"
              class="form-control"
              v-model="fm1_members.flat_num_2"
              :placeholder="$t('message.contracts.fm1_addrr_flat_num')"
              autocomplete="off"
              style="cursor: auto"
              id="fm1_addrr_flat_num"
            />
            <label
              for="fm1_addrr_flat_num"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.fm1_addrr_flat_num") }}</label
            >
          </span>
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              :disabled="is_field_readonly"
              type="text"
              class="form-control"
              v-model="fm1_members.post_index_2"
              :placeholder="$t('message.contracts.fm1_addrr_post_index')"
              autocomplete="off"
              style="cursor: auto"
              id="fm1_addrr_post_index"
            />
            <label
              for="fm1_addrr_post_index"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.fm1_addrr_post_index") }}</label
            >
          </span>
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              :disabled="is_field_readonly"
              type="text"
              class="form-control"
              v-model="fm1_members.fm1_memb_contact_phone_2"
              :placeholder="
                $t('message.contracts.fm1_members_fm1_memb_contact_phone')
              "
              autocomplete="off"
              style="cursor: auto"
              id="fm1_members_fm1_memb_contact_phone"
            />
            <label
              for="fm1_members_fm1_memb_contact_phone"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.fm1_members_fm1_memb_contact_phone")
              }}</label
            >
          </span>
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              :disabled="is_field_readonly"
              type="text"
              class="form-control"
              v-model="fm1_members.fm1_memb_email_2"
              :placeholder="$t('message.contracts.fm1_members_fm1_memb_email')"
              autocomplete="off"
              style="cursor: auto"
              id="fm1_members_fm1_memb_email"
            />
            <label
              for="fm1_members_fm1_memb_email"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.fm1_members_fm1_memb_email") }}</label
            >
          </span>
          <h4 class="text-dark">
            {{ $t("message.contracts.fm1_members_fm1_memb_fact_address") }}
          </h4>
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              :disabled="is_field_readonly"
              type="text"
              class="form-control"
              v-model="fm1_members.state_kaz_3"
              :placeholder="$t('message.contracts.fm1_addrr_state_kaz')"
              autocomplete="off"
              style="cursor: auto"
              id="fm1_addrr_state_kaz2"
            />
            <label
              for="fm1_addrr_state_kaz2"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.fm1_addrr_state_kaz") }}</label
            >
          </span>
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              :disabled="is_field_readonly"
              type="text"
              class="form-control"
              v-model="fm1_members.region_kaz_3"
              :placeholder="$t('message.contracts.fm1_addrr_region_kaz')"
              autocomplete="off"
              style="cursor: auto"
              id="fm1_addrr_region_kaz2"
            />
            <label
              for="fm1_addrr_region_kaz2"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.fm1_addrr_region_kaz") }}</label
            >
          </span>
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              :disabled="is_field_readonly"
              type="text"
              class="form-control"
              v-model="fm1_members.sity_kaz_3"
              :placeholder="$t('message.contracts.fm1_addrr_sity_kaz')"
              autocomplete="off"
              style="cursor: auto"
              id="fm1_addrr_sity_kaz2"
            />
            <label
              for="fm1_addrr_sity_kaz2"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.fm1_addrr_sity_kaz") }}</label
            >
          </span>
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              :disabled="is_field_readonly"
              type="text"
              class="form-control"
              v-model="fm1_members.street_3"
              :placeholder="$t('message.contracts.fm1_addrr_street')"
              autocomplete="off"
              style="cursor: auto"
              id="fm1_addrr_street2"
            />
            <label
              for="fm1_addrr_street2"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.fm1_addrr_street") }}</label
            >
          </span>
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              :disabled="is_field_readonly"
              type="text"
              class="form-control"
              v-model="fm1_members.house_num_3"
              :placeholder="$t('message.contracts.fm1_addrr_house_num')"
              autocomplete="off"
              style="cursor: auto"
              id="fm1_addrr_house_num2"
            />
            <label
              for="fm1_addrr_house_num2"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.fm1_addrr_house_num") }}</label
            >
          </span>
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              :disabled="is_field_readonly"
              type="text"
              class="form-control"
              v-model="fm1_members.flat_num_3"
              :placeholder="$t('message.contracts.fm1_addrr_flat_num')"
              autocomplete="off"
              style="cursor: auto"
              id="fm1_addrr_flat_num2"
            />
            <label
              for="fm1_addrr_flat_num2"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.fm1_addrr_flat_num") }}</label
            >
          </span>
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              :disabled="is_field_readonly"
              type="text"
              class="form-control"
              v-model="fm1_members.post_index_3"
              :placeholder="$t('message.contracts.fm1_addrr_post_index')"
              autocomplete="off"
              style="cursor: auto"
              id="fm1_addrr_post_index2"
            />
            <label
              for="fm1_addrr_post_index2"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.fm1_addrr_post_index") }}</label
            >
          </span>
          <translatable>
            <span
              :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']"
            >
              <input
                :disabled="is_field_readonly"
                type="text"
                class="form-control"
                v-model="fm1_members.fm1_memb_memb_add_info_3"
                :placeholder="
                  $t('message.contracts.fm1_members_fm1_memb_memb_add_info')
                "
                autocomplete="off"
                style="cursor: auto"
                id="fm1_members_fm1_memb_memb_add_info"
              />
              <label
                for="fm1_members_fm1_memb_memb_add_info"
                class="form-label-group-label shorter"
                >{{
                  $t("message.contracts.fm1_members_fm1_memb_memb_add_info")
                }}</label
              >
            </span>
          </translatable>
          <button
            v-if="!is_field_readonly"
            id="fm1-save-member-button"
            class="btn btn-success btn-sm"
            @click="show_fm1_member = false"
          >
            {{ $t("message.save") }}
          </button>
          <button
            class="btn btn-outline-danger btn-sm float-right"
            @click="show_fm1_member = false"
          >
            {{ $t("message.cancel") }}
          </button>
        </div>
        <button
          id="fm1-add-member-button"
          v-if="!show_fm1_member && !is_field_readonly"
          class="btn btn-outline-success btn-sm mb-4"
          @click="addMember()"
        >
          {{ $t("message.add") }}
        </button>
      </b-tab>
    </b-tabs>
    <div
      class="buttons"
      style="position: absolute; bottom: 16px; right: 20%; left: 20px"
    >
      <!--<button class="btn btn-success float-left" @click="saveDocument()" :disabled=buttons_loading>{{$t(is_new?'message.contracts.document_create':'message.contracts.document_save')}}</button>
			<button class="btn btn-outline-info mr-2 float-right" :disabled=buttons_loading>{{$t('message.contracts.fm1_validate')}}</button> -->
      <button
        v-if="!is_field_readonly"
        class="btn btn-outline-success btn-sm dropdown-toggle"
        type="button"
        id="dropdownMenuButton"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        :disabled="buttons_loading"
      >
        {{
          $t(
            is_new
              ? "message.contracts.document_create"
              : "message.contracts.document_save",
          )
        }}&nbsp;&nbsp;
        <div
          class="loading loading-button"
          v-if="loading"
          style="
            border-top-width: 2px;
            border-top-color: #4caf50;
            top: 30px;
            right: -93px;
          "
        ></div>
      </button>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <a
          id="create-fm1-button"
          class="dropdown-item"
          style="color: #4caf50"
          @click="saveDocument()"
          :disabled="buttons_loading"
          >{{
            $t(
              is_new
                ? "message.contracts.document_create"
                : "message.contracts.document_save",
            )
          }}</a
        >
        <a
          class="dropdown-item"
          style="color: #4caf50"
          v-if="!is_new"
          @click="submit_and_sign_dialog()"
          :disabled="buttons_loading"
          >{{ $t("message.contracts.submit_and_sign_button") }}</a
        >
      </div>
      <button
        @click="downloadKFM()"
        class="btn btn-outline-success btn-sm float-right"
        :disabled="buttons_loading"
      >
        {{ $t("message.contracts.fm1_kfm_xml") }}
      </button>
    </div>
    <b-modal
      id="modal-select-ecp-type-fm1"
      :hide-footer="true"
      size="sm"
      :title="$t('message.contracts.select_ecp_type')"
    >
      <div class="text-center" v-if="!show_code_sign_type">
        <button
          class="btn btn-outline-success btn-round"
          @click="signDocument()"
        >
          {{ $t("message.contracts.sign_with_ecp") }}
        </button>
        <div>
          <small>
            <i>
              {{ $t("message.contracts.only_for_kz") }}
            </i>
          </small>
        </div>
        <hr />
        <button
          class="btn btn-outline-success btn-round"
          @click="sign_with_code()"
        >
          {{ $t("message.contracts.sign_with_code") }}
        </button>
      </div>
      <div class="text-center" v-if="show_code_sign_type">
        <div class="form-group">
          <label for="input-code">
            {{ $t("message.contracts.input_signature_code") }}
          </label>
          <input
            type="text"
            class="form-control"
            id="input-code"
            v-model="sign_with_code_code"
          />
        </div>
        <button
          class="btn btn-success btn-round"
          @click="sign_with_code_phase2()"
        >
          {{ $t("message.contracts.sign_with_code") }}
        </button>
        <hr />
        <button
          class="btn btn-default btn-round btn-sm"
          @click="show_code_sign_type = false"
        >
          {{ $t("message.cancel") }}
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
var FileSaver = require("file-saver");
var querystring = require("querystring");
import { required } from "vuelidate/lib/validators";
export default {
  props: ["goods", "contract_details", "document_id", "is_new", "document"],
  data() {
    return {
      buttons_loading: false,

      show_code_sign_type: false,
      sign_with_code_code: "",
      add_product: false,
      edit_product: false,
      currently_editing: false,
      form_error: false,
      product_error: false,
      currency_focused: false,
      placeholder_currency: false,
      buyer_focused: false,
      seller_focused: false,
      buyer2_focused: false,
      seller2_focused: false,
      tnved_focused: false,
      placeholder_tnved: false,
      placeholder_measure: false,
      measure_focused: false,
      placeholder_delivery: false,
      delivery_focused: false,
      country_focused: false,
      currencies: [],
      measures: [],
      companies: [],
      countries: [],
      tnveds: [],
      okeds: [],
      delivery_terms: [],
      org_forms: [],
      code_types: [],
      code_eknps: [],
      oper_basises: [],
      oper_codes: [],
      fm1_memb_subj_kinds: [],
      is_fiz_lico: false,

      oked_focused: false,
      fm1_memb_founder_org_form_focus: false,
      percent_focused: false,
      fm1_memb_org_form_focus: false,
      fm1_memb_country_focus: false,
      fm1_memb_country2_focus: false,
      fm1_memb_subj_kind_focus: false,
      discount_focused: false,
      fm1_subj_org_form_focus: false,
      fm1_oper_code_type_focus: false,
      fm1_oper_eknp_focus: false,
      fm1_oper_currency_focus: false,
      fm1_oper_basis_focus: false,
      fm1_oper_code_focus: false,

      fm1_oper_1code_focus: false,
      fm1_oper_2code_focus: false,
      fm1_oper_3code_focus: false,

      fm1_main_reason_focus: false,
      fm1_main_form_state_focus: false,
      fm1_main_doc_kind_focus: false,
      fm1_main_subreason_focus: false,

      show_fm1_member: false,

      cleave_12_digits: {
        numeral: false,
        numericOnly: true,
        numeralDecimalScale: 0,
        numeralPositiveOnly: true,
        blocks: [12],
      },
      cleavePQTY: {
        numeral: false,
        numericOnly: true,
        numeralDecimalScale: 0,
        numeralPositiveOnly: true,
        blocks: [8],
      },
      cleaveWeight: {
        numeral: true,
        // numericOnly: true,
        // numeralDecimalScale: 0,
        numeralPositiveOnly: true,
        blocks: [24],
        numeralDecimalScale: 6,
      },
      cleavePrice: {
        numeral: true,
        // numericOnly: true,
        // numeralDecimalScale: 0,
        numeralPositiveOnly: true,
        blocks: [20],
        numeralDecimalScale: 2,
      },
      fm1_main_doc_kinds: [
        {
          display_text: this.$t("message.contracts.fm1_main_doc_kind_1"),
          value: 1,
        },
        {
          display_text: this.$t("message.contracts.fm1_main_doc_kind_2"),
          value: 2,
        },
        {
          display_text: this.$t("message.contracts.fm1_main_doc_kind_3"),
          value: 3,
        },
      ],
      fm1_main_form_states: [
        {
          display_text: this.$t("message.contracts.fm1_main_form_state_1"),
          value: 1,
        },
        {
          display_text: this.$t("message.contracts.fm1_main_form_state_2"),
          value: 2,
        },
        {
          display_text: this.$t("message.contracts.fm1_main_form_state_3"),
          value: 3,
        },
        {
          display_text: this.$t("message.contracts.fm1_main_form_state_4"),
          value: 4,
        },
      ],
      fm1_main_reasons: [
        {
          display_text: this.$t("message.contracts.fm1_main_reason_1"),
          value: 1,
        },
        {
          display_text: this.$t("message.contracts.fm1_main_reason_2"),
          value: 2,
        },
      ],
      fm1_main_subreasons: [
        {
          display_text: this.$t("message.contracts.fm1_main_reason_sub_1"),
          value: 1,
        },
        {
          display_text: this.$t("message.contracts.fm1_main_reason_sub_2"),
          value: 2,
        },
        {
          display_text: this.$t("message.contracts.fm1_main_reason_sub_3"),
          value: 3,
        },
      ],
      fm1_members_members: [
        {
          display_text: this.$t("message.contracts.fm1_fm1_member_payer"),
          value: "1",
        },
        {
          display_text: this.$t("message.contracts.fm1_fm1_member_recipient"),
          value: "2",
        },
        {
          display_text: this.$t(
            "message.contracts.fm1_fm1_member_payer_representative",
          ),
          value: "3",
        },
        {
          display_text: this.$t(
            "message.contracts.fm1_fm1_member_recipient_representative",
          ),
          value: "4",
        },
        {
          display_text: this.$t(
            "message.contracts.fm1_fm1_member_face_in_name_of",
          ),
          value: "5",
        },
        {
          display_text: this.$t("message.contracts.fm1_fm1_member_beneficiary"),
          value: "6",
        },
      ],
      fm1_memb_types: [
        { display_text: this.$t("message.contracts.fm1_memb_type1"), value: 1 },
        { display_text: this.$t("message.contracts.fm1_memb_type2"), value: 2 },
        { display_text: this.$t("message.contracts.fm1_memb_type3"), value: 3 },
      ],
      fm1_memb_foreigns: [
        {
          display_text: this.$t("message.contracts.fm1_memb_foreign1"),
          value: 1,
        },
        {
          display_text: this.$t("message.contracts.fm1_memb_foreign2"),
          value: 2,
        },
        {
          display_text: this.$t("message.contracts.fm1_memb_foreign3"),
          value: 3,
        },
      ],
      fm1_memb_org_forms: [
        {
          display_text: this.$t("message.contracts.fm1_memb_org_form_1"),
          value: 1,
        },
        {
          display_text: this.$t("message.contracts.fm1_memb_org_form_2"),
          value: 2,
        },
        {
          display_text: this.$t("message.contracts.fm1_memb_org_form_3"),
          value: 3,
        },
        {
          display_text: this.$t("message.contracts.fm1_memb_org_form_4"),
          value: 4,
        },
        {
          display_text: this.$t("message.contracts.fm1_memb_org_form_5"),
          value: 5,
        },
      ],
      fm1_main: {
        fm1_main_related_number: "",
        fm1_main_related_date: "",
        fm1_main_date: "",
        fm1_main_doc_kind: { value: "" },
        fm1_main_form_state: { value: "" },
        fm1_main_reason: { value: "" },
        fm1_main_subreason: { value: "" },
        SignDate: "",
        SignatureName: "",
        SignatureType: "",
        IsSigned: false,
      },
      fm1_members_list: [],
      fm1_members_fields: [
        {
          key: "fm1_memb_company_name",
          label: this.$t("message.contracts.fm1_members_fm1_memb_company_name")
            .replace(":", "")
            .replace("1.2. ", ""),
        },
        {
          key: "action",
          label: "",
        },
      ],

      fm1_subject: {
        fm1_subj_code: "",
        fm1_subj_org_form: { value: "" },
        fm1_subj_name: "",
        fm1_subj_pers_second_name: "",
        fm1_subj_pers_name: "",
        fm1_subj_pers_middle_name: "",
        fm1_subj_rnn: "",
        fm1_subj_iin_bin: "",
        fm1_subj_manager_second_name: "",
        fm1_subj_manager_name: "",
        fm1_subj_manager_patronymic: "",
        fm1_subj_position: "",
        fm1_subj_phone: "",
        fm1_subj_email: "",
      },
      fm1_addrr: {
        state_kaz: "",
        region_kaz: "",
        sity_kaz: "",
        street: "",
        house_num: "",
        flat_num: "",
        post_index: "",
      },
      fm1_docs: {
        doc_num: "",
        doc_series: "",
        goverm_office: "",
        doc_date: "",
      },

      fm1_oper: {
        fm1_oper_number: "",
        fm1_oper_code_type: { value: "" },
        fm1_oper_eknp: { value: "" },
        fm1_oper_members_quant: "",
        fm1_oper_currency: { value: "" },
        fm1_oper_curr_code: "",
        fm1_oper_tenge_sum: "",
        fm1_oper_basis: { value: "" },

        fm1_oper_basis_doc_date: "",
        fm1_oper_basis_doc_num: "",
        fm1_oper_1code: { value: "" },
        fm1_oper_2code: { value: "" },
        fm1_oper_3code: { value: "" },
        fm1_oper_trouble_desc: "",
        fm1_oper_add_info: "",
      },
      fm1_members: {
        fm1_member: [],
        fm1_memb_is_subj: false,
        fm1_memb_subj_kind: { value: "" },
        fm1_memb_country: { value: "" },
        fm1_memb_type: "",
        fm1_memb_foreign: "",
        fm1_memb_bank_branch_place: "",
        fm1_memb_bank_branch: "",
        fm1_memb_sdp: "",
        fm1_memb_branch_code: "",
        fm1_memb_acc: "",
        fm1_memb_bank_place: "",
        fm1_memb_bank_name: "",
        fm1_memb_org_form: { value: "" },
        fm1_memb_company_name: "",
        fm1_memb_noname: "",
        fm1_memb_founder_org_form: { value: "" },
        fm1_memb_founder_: "",
        fm1_memb_founder_secondname: "",
        fm1_memb_founder_name: "",
        fm1_memb_founder_patronymic: "",
        fm1_memb_country_2: { value: "" },
        oked: { value: "" },
        iin_bin: "",
        fm1_person_secondname: "",
        fm1_person_name: "",
        fm1_person_midle_name: "",
        fm1_person_secondname_2: "",
        fm1_person_name_2: "",
        fm1_person_middle_name_2: "",
        doc_type_2: "",
        doc_num_2: "",
        doc_series_2: "",
        goverm_office_2: "",
        doc_date_2: "",
        fm1_person_birth_date: "",
        fm1_person_birth_place: "",
        state_kaz_2: "",
        region_kaz_2: "",
        sity_kaz_2: "",
        street_2: "",
        house_num_2: "",
        flat_num_2: "",
        post_index_2: "",
        fm1_memb_contact_phone_2: "",
        fm1_memb_email_2: "",
        state_kaz_3: "",
        region_kaz_3: "",
        sity_kaz_3: "",
        street_3: "",
        house_num_3: "",
        flat_num_3: "",
        post_index_3: "",
        fm1_memb_memb_add_info_3: "",
      },
      fm1_persons: {
        fm1_person_secondname: "",
        fm1_person_name: "",
        fm1_person_midle_name: "",
        fm1_person_secondname_2: "",
        fm1_person_name_2: "",
        fm1_person_middle_name_2: "",
        fm1_person_birth_date: "",
        fm1_person_birth_place: "",
      },
      fm1_docs2: {
        doc_type: "",
        doc_num: "",
        doc_series: "",
        goverm_office: "",
        doc_date: "",
      },
      fm1_addrr2: {
        state_kaz: "",
        region_kaz: "",
        sity_kaz: "",
        street: "",
        house_num: "",
        flat_num: "",
        post_index: "",
        fm1_memb_contact_phone: "",
        fm1_memb_email: "",
      },
      fm1_addrr3: {
        state_kaz: "",
        region_kaz: "",
        sity_kaz: "",
        street: "",
        house_num: "",
        flat_num: "",
        post_index: "",
        fm1_memb_memb_add_info: "",
      },

      CMR: {
        cmr_number: "",
        cmr_date: "",
        cmr_sender: { display_text: "", value: "" },
        cmr_recipient: { display_text: "", value: "" },
        cmr_courier: { display_text: "", value: "" },
        cmr_courier_next: { display_text: "", value: "" },
        cmr_track: "",
        cmr_trailer: "",
      },

      ContractDeliveryTerms: {
        DeliveryPlace: "",
        DeliveryTermsStringCode: { display_text: "", value: "" },
        TermsDescription: "",
      },

      TakingCargoPlace: {
        CountryCode: { display_text: "", value: "" },
        City: "",
        StreetHouse: "",
        PostalCode: "",
        TakingCargoDate: "",
      },

      EnclosedDocument: {
        PrDocumentName: "",
        PrDocumentNumber: "",
        PrDocumentDate: "",
      },
      CMRGoods: [],
      CMRGood: {
        GoodsMarking: "",
        GoodsQuantity: "",
        GoodsDescription: "",
        GoodsNomenclatureCode: { display_text: "", value: "" },
        GrossWeightQuantity: "",
        VolumeQuantity: "",
      },

      ConsigneeCustoms: {
        WarehouseName: "",
      },
      product_fields: [
        {
          key: "GoodsMarking",
          label: this.$t("message.contracts.cmr_products_GoodsMarking"),
          sortable: false,
        },
        {
          key: "GoodsQuantity",
          label: this.$t("message.contracts.cmr_products_GoodsQuantity"),
          sortable: false,
        },
        {
          key: "GoodsDescription",
          label: this.$t("message.contracts.cmr_products_GoodsQuantity"),
          sortable: false,
        },
        {
          key: "GrossWeightQuantity",
          label: this.$t("message.contracts.cmr_products_GrossWeightQuantity"),
          sortable: false,
        },
        {
          key: "VolumeQuantity",
          label: this.$t("message.contracts.cmr_products_VolumeQuantity"),
          sortable: false,
        },
        {
          key: "remove",
          label: "",
        },
      ],
    };
  },
  methods: {
    downloadKFM() {
      axios
        .get(window.base + "/document/LoadFm1Xml?id=" + this.document_id)
        .then((response) => {
          var blob = new Blob([response.data], { type: "text/xml" });
          FileSaver.saveAs(blob, "fm1.xml");
        });
    },
    submit_and_sign_dialog() {
      this.$bvModal.show("modal-select-ecp-type-fm1");
    },
    signDocument() {
      this.loading = true;
      axios
        .get(window.base + "/document/LoadFm1XmlDoc?id=" + this.document_id)
        .then((response) => {
          this.xml = response.data.replace(
            '<?xml version="1.0" encoding="utf-16"?>',
            "",
          );
          window.webSocket = new WebSocket("wss://127.0.0.1:13579/");
          window.callback = null;

          window.webSocket.onopen = (event) => {
            window.signXml("PKCS12", "SIGNATURE", this.xml, () => {});
          };

          window.webSocket.onclose = function (event) {
            if (event.wasClean) {
            } else {
              openDialog();
            }
          };

          window.webSocket.onmessage = (event) => {
            var result = JSON.parse(event.data);
            if (result != null) {
              var rw = {
                code: result["code"],
                message: result["message"],
                responseObject: result["responseObject"],
                getResult: function () {
                  return this.result;
                },
                getMessage: function () {
                  return this.message;
                },
                getResponseObject: function () {
                  return this.responseObject;
                },
                getCode: function () {
                  return this.code;
                },
              };
              if (rw.code == "200") {
                var oParser = new DOMParser();
                var oDOM = oParser.parseFromString(
                  rw.getResponseObject(),
                  "application/xml",
                );
                var value =
                  oDOM.getElementsByTagName("ds:SignatureValue")[0].innerHTML;
                var certificate =
                  oDOM.getElementsByTagName("ds:X509Certificate")[0].innerHTML;

                axios
                  .get(window.base + "/account/loadSignatureDetails")
                  .then((response) => {
                    let cert = response.data.cert.replace(
                      /(?:\r\n|\r|\n)/g,
                      "",
                    );
                    if (cert == certificate.replace(/(?:\r\n|\r|\n)/g, "")) {
                      var fd = new FormData();
                      fd.append("document_id", this.document_id);
                      fd.append("contract_id", this.document_id);
                      fd.append("signature", value);
                      fd.append("type", "signature");
                      axios
                        .post(
                          window.base + "/document/AddDocumentSignature",
                          fd,
                        )
                        .then(() => {
                          this.loading = false;
                          this.load(); //refresh status of the contract
                          new Noty({
                            theme: "light",
                            type: "success",
                            text: this.$t("message.message.document_signed"),
                            timeout: 5000,
                          }).show();
                          this.$bvModal.hide("modal-select-ecp-type-fm1");
                        })
                        .catch((e) => {
                          this.loading = false;
                          new Noty({
                            theme: "light",
                            type: "error",
                            text:
                              this.$t("message.message.document_not_signed") +
                              " (" +
                              e +
                              ")",
                            timeout: 5000,
                          }).show();
                          this.$bvModal.hide("modal-select-ecp-type-fm1");
                        });
                    } else {
                      this.loading = false;
                      new Noty({
                        theme: "light",
                        type: "error",
                        text: this.$t(
                          "message.message.document_not_signed_cert_invalid",
                        ),
                        timeout: 5000,
                      }).show();
                    }
                  });

                // var fd = new FormData;
                // fd.append('contract_id', this.document_id)
                // fd.append('signature', value)
                // axios.post(window.base + '/document/AddDocumentSignature', fd).then(()=>{
                // 	this.loading = false
                // 	new Noty({
                // 		theme: 'light',
                // 		type: 'success',
                // 		text: this.$root.$t('message.message.document_signed'),
                // 		timeout: 5000,
                // 	}).show();
                // 	this.$bvModal.hide('modal-select-ecp-type-invoice')
                // }).catch(e=>{
                // 	this.loading = false
                // 	new Noty({
                // 		theme: 'light',
                // 		type: 'error',
                // 		text: this.$root.$t('message.message.document_not_signed'),
                // 		timeout: 5000,
                // 	}).show();
                // 	this.$bvModal.hide('modal-select-ecp-type-invoice')
                // })
                window.webSocket.close();
                // window.webSocket.removeEventListener('message', {})
              }
            }
          };
        });
    },
    sign_with_code() {
      axios
        .get(window.base + "/account/GenerateToken?doc_id=" + this.document_id)
        .then((response) => {
          console.log(response.data);
          this.show_code_sign_type = true;
        });
    },
    sign_with_code_phase2() {
      if (this.sign_with_code_code != "") {
        axios
          .get(window.base + "/document/LoadFm1XmlDoc?id=" + this.document_id)
          .then((response) => {
            var fd = new FormData();
            var xml = response.data.replace(
              '<?xml version="1.0" encoding="utf-16"?>',
              "",
            );
            fd.append("token", this.sign_with_code_code);
            fd.append("data", xml);
            axios
              .post(window.base + "/account/SignData", fd)
              .then((response) => {
                var fd = new FormData();
                fd.append("contract_id", this.document_id);
                fd.append("signature", response.data);
                axios
                  .post(window.base + "/document/AddDocumentSignature", fd)
                  .then(() => {
                    this.loading = false;
                    new Noty({
                      theme: "light",
                      type: "success",
                      text: this.$root.$t("message.message.contract_signed"),
                      timeout: 5000,
                    }).show();
                    this.$bvModal.hide("modal-select-ecp-type-fm1");
                  })
                  .catch((e) => {
                    this.loading = false;
                    new Noty({
                      theme: "light",
                      type: "error",
                      text: this.$root.$t(
                        "message.message.contract_not_signed",
                      ),
                      timeout: 5000,
                    }).show();
                    this.$bvModal.hide("modal-select-ecp-type-fm1");
                  });
              });
          });
      }
    },
    addMember() {
      this.fm1_members_list.push({
        fm1_member: [],
        fm1_memb_is_subj: false,
        fm1_memb_subj_kind: { value: "" },
        fm1_memb_country: { value: "" },
        fm1_memb_type: "",
        fm1_memb_foreign: "",
        fm1_memb_bank_branch_place: "",
        fm1_memb_bank_branch: "",
        fm1_memb_sdp: "",
        fm1_memb_branch_code: "",
        fm1_memb_acc: "",
        fm1_memb_bank_place: "",
        fm1_memb_bank_name: "",
        fm1_memb_org_form: { value: "" },
        fm1_memb_company_name: "",
        fm1_memb_noname: "",
        fm1_memb_founder_org_form: { value: "" },
        fm1_memb_founder_: "",
        fm1_memb_founder_secondname: "",
        fm1_memb_founder_name: "",
        fm1_memb_founder_patronymic: "",
        fm1_memb_country_2: { value: "" },
        oked: { value: "" },
        iin_bin: "",
        fm1_person_secondname: "",
        fm1_person_name: "",
        fm1_person_midle_name: "",
        fm1_person_secondname_2: "",
        fm1_person_name_2: "",
        fm1_person_middle_name_2: "",
        doc_type_2: "",
        doc_num_2: "",
        doc_series_2: "",
        goverm_office_2: "",
        doc_date_2: "",
        fm1_person_birth_date: "",
        fm1_person_birth_place: "",
        state_kaz_2: "",
        region_kaz_2: "",
        sity_kaz_2: "",
        street_2: "",
        house_num_2: "",
        flat_num_2: "",
        post_index_2: "",
        fm1_memb_contact_phone_2: "",
        fm1_memb_email_2: "",
        state_kaz_3: "",
        region_kaz_3: "",
        sity_kaz_3: "",
        street_3: "",
        house_num_3: "",
        flat_num_3: "",
        post_index_3: "",
        fm1_memb_memb_add_info_3: "",
      });
      this.fm1_members =
        this.fm1_members_list[this.fm1_members_list.length - 1];
      this.show_fm1_member = true;
    },
    removeMember(item) {
      this.fm1_members_list.splice(item, 1);
      this.show_fm1_member = false;
    },
    openMember(item) {
      this.fm1_members = item;
      this.show_fm1_member = true;
    },
    fetchDeliveryTerms(search, loading) {
      this.getLibrary("delivery_term", search, 10000);
    },
    fetchMembSubjKind(search, loading) {
      this.getLibrary("fm1_memb_subj_kind", search, 10000);
    },
    addCourier() {
      this.$bvModal.show("modal-add-courier");
    },
    addCourierNext() {
      this.$bvModal.show("modal-add-courier-next");
    },
    addSender() {
      this.$bvModal.show("modal-add-sender");
    },
    addRecipient() {
      this.$bvModal.show("modal-add-recipient");
    },
    findLibValueProduct(lib, value, field, index) {
      if (typeof lib == "string") {
        axios
          .get(
            window.base +
              "/library?type=" +
              lib +
              "&query=&qty=1000" +
              "&lang=" +
              this.$i18n.locale,
          )
          .then((response) => {
            response.data.forEach((item) => {
              if (item.value == value) {
                this.$set(this.CMRGoods[index], field, item);
              }
            });
          });
      }
    },
    findLibValue(lib, value, object, field) {
      if (typeof lib == "string") {
        axios
          .get(
            window.base +
              "/library?type=" +
              lib +
              "&query=&qty=1000" +
              "&lang=" +
              this.$i18n.locale,
          )
          .then((response) => {
            response.data.forEach((item) => {
              if (item.value == value) {
                this.$set(this[object], field, item);
              }
            });
          });
      } else {
        lib.forEach((item) => {
          if (item.value == value) this.$set(this.Invoice, field, item);
        });
      }
    },
    saveProduct() {
      this.$v.$touch("CMRGood");
      if (this.$v.CMRGood.$invalid) {
        this.product_error = true;
        setTimeout(() => {
          $("html,body").animate(
            { scrollTop: $(".has-danger").eq(0).offset().top - 50 },
            1000,
          );
        }, 100);
      } else {
        this.product_error = false;
        this.hideEditProduct();
      }
    },
    hideEditProduct() {
      this.CMRGood = {
        GoodsMarking: "",
        GoodsQuantity: "",
        GoodsDescription: "",
        GoodsNomenclatureCode: { display_text: "", value: "" },
        GrossWeightQuantity: "",
        VolumeQuantity: "",
      };
      this.edit_product = false;
    },
    editProduct(index) {
      this.edit_product = true;
      this.CMRGood = this.CMRGoods[index];
      this.currently_editing = index;
    },
    removeProduct(index) {
      this.CMRGoods.splice(index, 1);
    },
    addProduct() {
      this.$v.$touch("CMRGood");
      if (this.$v.CMRGood.$invalid) {
        this.product_error = true;
        setTimeout(() => {
          $("html,body").animate(
            { scrollTop: $(".has-danger").eq(0).offset().top - 50 },
            1000,
          );
        }, 100);
      } else {
        this.product_error = false;
        this.CMRGoods.push({
          GoodMarking: this.CMRGood.GoodMarking,
          GoodsNomenclatureCode: this.CMRGood.GoodsNomenclatureCode,
          GoodsDescription: this.CMRGood.GoodsDescription,
          GoodsQuantity: this.CMRGood.GoodsQuantity,
          GrossWeightQuantity: this.CMRGood.GrossWeightQuantity,
          VolumeQuantity: this.CMRGood.VolumeQuantity,
        });
        this.hideAddProduct();
      }
    },
    showAddProduct() {
      this.add_product = true;
    },
    hideAddProduct() {
      this.add_product = false;
      this.CMRGood = {
        GoodsMarking: "",
        GoodsQuantity: "",
        GoodsDescription: "",
        GoodsNomenclatureCode: { display_text: "", value: "" },
        GrossWeightQuantity: "",
        VolumeQuantity: "",
      };
    },
    getLibrary(type, query, qty) {
      query = query.toLowerCase();
      axios
        .get(
          window.base +
            "/library?type=" +
            type +
            "&query=" +
            query +
            "&qty=" +
            qty +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          var var_name = type;
          if (type[type.length - 1] == "s") {
            var_name = type + "es";
          } else if (type[type.length - 1] == "y") {
            var_name = type.substring(0, type.length - 1) + "ies";
          } else {
            var_name = type + "s";
          }
          this.$data[var_name] = [];
          response.data.forEach((item) => {
            if (item.value !== "··········") this.$data[var_name].push(item);
          });
        });
    },
    fetchCurrency(search, loading) {
      this.getLibrary("currency", search, 10000);
    },
    fetchCountries(search, loading) {
      this.getLibrary("country", search, 10000);
    },
    fetchTNVED(search, loading) {
      this.getLibrary("tnved", search, 10000);
    },
    fetchMeasures(search, loading) {
      this.getLibrary("measure", search, 10000);
    },
    fetchCurrencies() {
      this.getLibrary("currency", "", 10000);
    },
    fetchContragents(search, loading) {
      this.getLibrary("company", search, 10000);
    },
    fetchorg_form(search, loading) {
      this.getLibrary("org_form", search, 10000);
    },
    fetchFm1CodeType() {
      this.getLibrary("code_type", "", 10000);
    },
    fetchFm1CodeEknp() {
      this.getLibrary("code_eknp", "", 10000);
    },
    fetchFm1OperBasis() {
      this.getLibrary("oper_basis", "", 10000);
    },
    fetchFm1OperCode() {
      this.getLibrary("oper_code", "", 10000);
    },
    fm1_subj_org_form_Focused() {
      this.fm1_subj_org_form_focus = true;
    },
    fm1_main_subreason_Focused() {
      this.fm1_main_subreason_focus = true;
    },
    fm1_main_subreasonBlurred() {
      this.fm1_main_subreason_focus = false;
    },
    fm1_subj_org_formBlurred() {
      this.fm1_subj_org_form_focus = false;
    },
    fm1_oper_code_type_Focused() {
      this.fm1_oper_code_type_focus = true;
    },
    fm1_oper_code_typeBlurred() {
      this.fm1_oper_code_type_focus = false;
    },
    fm1_oper_eknp_Focused() {
      this.fm1_oper_eknp_focus = true;
    },
    fm1_oper_eknpBlurred() {
      this.fm1_oper_eknp_focus = false;
    },
    fm1_oper_basis_Focused() {
      this.fm1_oper_basis_focus = true;
    },
    fm1_oper_basisBlurred() {
      this.fm1_oper_basis_focus = false;
    },
    fm1_oper_1code_Focused() {
      this.fm1_oper_1code_focus = true;
    },
    fm1_oper_1codeBlurred() {
      this.fm1_oper_1code_focus = false;
    },
    fm1_oper_2code_Focused() {
      this.fm1_oper_2code_focus = true;
    },
    fm1_oper_2codeBlurred() {
      this.fm1_oper_2code_focus = false;
    },
    fm1_oper_3code_Focused() {
      this.fm1_oper_3code_focus = true;
    },
    fm1_oper_3codeBlurred() {
      this.fm1_oper_3code_focus = false;
    },
    fm1_memb_country2_Focused() {
      this.fm1_memb_country2_focus = true;
    },
    fm1_memb_country2Blurred() {
      this.fm1_memb_country2_focus = false;
    },

    fm1_main_reason_Focused() {
      this.fm1_main_reason_focus = true;
    },
    fm1_main_reasonBlurred() {
      this.fm1_main_reason_focus = false;
    },
    fm1_main_form_state_Focused() {
      this.fm1_main_form_state_focus = true;
    },
    fm1_main_form_stateBlurred() {
      this.fm1_main_form_state_focus = false;
    },
    fm1_main_doc_kind_Focused() {
      this.fm1_main_doc_kind_focus = true;
    },
    fm1_main_doc_kindBlurred() {
      this.fm1_main_doc_kind_focus = false;
    },
    fm1_memb_subj_kind_Focused() {
      this.fm1_memb_subj_kind_focus = true;
    },
    fm1_memb_subj_kindBlurred() {
      this.fm1_memb_subj_kind_focus = false;
    },
    fm1_oper_currency_Focused() {
      this.fm1_oper_currency_focus = true;
    },
    fm1_oper_currencyBlurred() {
      this.fm1_oper_currency_focus = false;
    },
    fm1_memb_country_Focused() {
      this.fm1_memb_country_focus = true;
    },
    fm1_memb_countryBlurred() {
      this.fm1_memb_country_focus = false;
    },
    fm1_memb_org_form_Focused() {
      this.fm1_memb_org_form_focus = true;
    },
    fm1_memb_org_formBlurred() {
      this.fm1_memb_org_form_focus = false;
    },
    fm1_memb_founder_org_form_Focused() {
      this.fm1_memb_founder_org_form_focus = true;
    },
    fm1_memb_founder_org_formBlurred() {
      this.fm1_memb_founder_org_form_focus = false;
    },

    fetchOkeds(search, loading) {
      this.getLibrary("oked", search, 10000);
    },
    okedsFocused() {
      this.oked_focused = true;
    },
    okedsBlurred() {
      this.oked_focused = false;
      this.validateField("company_oked");
    },

    currenciesFocused() {
      this.currency_focused = true;
    },
    currenciesBlurred() {
      this.currency_focused = false;
      // this.validateField('company_status')
    },
    buyerFocused() {
      this.buyer_focused = true;
    },
    buyerBlurred() {
      this.buyer_focused = false;
      // this.validateField('company_status')
    },
    sellerFocused() {
      this.buyer_focused = true;
    },
    sellerBlurred() {
      this.buyer_focused = false;
      // this.validateField('company_status')
    },
    buyer2Focused() {
      this.buyer_focused = true;
    },
    buyer2Blurred() {
      this.buyer_focused = false;
      // this.validateField('company_status')
    },
    seller2Focused() {
      this.buyer_focused = true;
    },
    seller2Blurred() {
      this.buyer_focused = false;
      // this.validateField('company_status')
    },
    tnvedFocused() {
      this.tnved_focused = true;
    },
    tnvedBlurred() {
      this.tnved_focused = false;
      // this.validateField('product.attis_cg_TNVED')
    },
    measureFocus() {
      this.measure_focused = true;
    },
    measureBlur() {
      this.measure_focused = false;
      // this.validateField('product.attis_cg_TNVED')
    },
    countryFocus() {
      this.country_focused = true;
    },
    countryBlur() {
      this.country_focused = false;
      // this.validateField('product.attis_cg_TNVED')
    },
    deliveryFocused() {
      this.delivery_focused = true;
    },
    deliveryBlurred() {
      this.delivery_focused = false;
      // this.validateField('product.attis_cg_TNVED')
    },
    load() {
      axios
        .get(window.base + "/Document/LoadFM1/?id=" + this.document_id)
        .then((response) => {
          this.$emit("file", response.data.files);

          this.fm1_main.SignDate = response.data.SignDate;

          this.fm1_main.SignatureType = response.data.SignatureType;
          this.fm1_main.SignatureName = response.data.SignatureName;
          this.fm1_main.IsSigned = response.data.IsSigned;

          this.fm1_main.fm1_main_related_number =
            response.data.fm1_main_related_number;

          this.fm1_main.fm1_main_related_date =
            response.data.fm1_main_related_date;

          this.fm1_main.fm1_main_date = response.data.fm1_main_date;

          this.fm1_main.fm1_main_doc_kind =
            this.fm1_main_doc_kinds[
              this.fm1_main_doc_kinds.findIndex(
                (i) =>
                  i.value == String(response.data.fm1_main_doc_kind).trim(),
              )
            ];

          this.fm1_main.fm1_main_form_state =
            this.fm1_main_form_states[
              this.fm1_main_form_states.findIndex(
                (i) =>
                  i.value == String(response.data.fm1_main_form_state).trim(),
              )
            ];

          this.fm1_main.fm1_main_reason =
            this.fm1_main_reasons[
              this.fm1_main_reasons.findIndex(
                (i) => i.value == String(response.data.fm1_main_reason).trim(),
              )
            ];

          this.fm1_main.fm1_main_subreason =
            this.fm1_main_subreasons[
              this.fm1_main_subreasons.findIndex(
                (i) =>
                  i.value == String(response.data.fm1_main_subreason).trim(),
              )
            ];

          this.fm1_subject.fm1_subj_code = response.data.fm1_subj_code;

          this.findLibValue(
            "org_form",
            String(response.data.fm1_subj_org_form).trim(),
            "fm1_subject",
            "fm1_subj_org_form",
          );

          this.fm1_subject.fm1_subj_name = response.data.fm1_subj_name;

          this.fm1_subject.fm1_subj_pers_second_name =
            response.data.fm1_subj_pers_second_name;

          this.fm1_subject.fm1_subj_pers_name =
            response.data.fm1_subj_pers_name;

          this.fm1_subject.fm1_subj_pers_middle_name =
            response.data.fm1_subj_pers_middle_name;

          this.fm1_subject.fm1_subj_rnn = response.data.fm1_subj_rnn;

          this.fm1_subject.fm1_subj_iin_bin = response.data.fm1_subj_iin_bin;

          this.fm1_subject.fm1_subj_manager_second_name =
            response.data.fm1_subj_manager_second_name;

          this.fm1_subject.fm1_subj_manager_name =
            response.data.fm1_subj_manager_name;

          this.fm1_subject.fm1_subj_manager_patronymic =
            response.data.fm1_subj_manager_patronymic;

          this.fm1_subject.fm1_subj_position = response.data.fm1_subj_position;

          this.fm1_subject.fm1_subj_phone = response.data.fm1_subj_phone;

          this.fm1_subject.fm1_subj_email = response.data.fm1_subj_email;

          this.fm1_addrr.state_kaz = response.data.state_kaz_1;

          this.fm1_addrr.region_kaz = response.data.region_kaz_1;

          this.fm1_addrr.sity_kaz = response.data.sity_kaz_1;

          this.fm1_addrr.street = response.data.street_1;

          this.fm1_addrr.house_num = response.data.house_num_1;

          this.fm1_addrr.flat_num = response.data.flat_num_1;

          this.fm1_addrr.post_index = response.data.post_index_1;

          this.fm1_docs.doc_num = response.data.doc_num;

          this.fm1_docs.doc_series = response.data.doc_series;

          this.fm1_docs.goverm_office = response.data.goverm_office;

          this.fm1_docs.doc_date = response.data.doc_date;

          this.fm1_oper.fm1_oper_number = response.data.fm1_oper_number;

          this.findLibValue(
            "code_type",
            String(response.data.fm1_oper_code_type).trim(),
            "fm1_oper",
            "fm1_oper_code_type",
          );

          this.findLibValue(
            "code_eknp",
            String(response.data.fm1_oper_eknp).trim(),
            "fm1_oper",
            "fm1_oper_eknp",
          );

          this.fm1_oper.fm1_oper_members_quant =
            response.data.fm1_oper_members_quant;

          this.findLibValue(
            "currency",
            String(response.data.fm1_oper_currency).trim(),
            "fm1_oper",
            "fm1_oper_currency",
          );

          this.fm1_oper.fm1_oper_curr_code = response.data.fm1_oper_curr_code;

          this.fm1_oper.fm1_oper_tenge_sum = response.data.fm1_oper_tenge_sum;

          this.findLibValue(
            "oper_basis",
            String(response.data.fm1_oper_basis).trim(),
            "fm1_oper",
            "fm1_oper_basis",
          );

          this.fm1_oper.fm1_oper_basis_doc_date =
            response.data.fm1_oper_basis_doc_date;

          this.fm1_oper.fm1_oper_basis_doc_num =
            response.data.fm1_oper_basis_doc_num;

          this.findLibValue(
            "oper_code",
            String(response.data.fm1_oper_1code).trim(),
            "fm1_oper",
            "fm1_oper_1code",
          );

          this.findLibValue(
            "oper_code",
            String(response.data.fm1_oper_2code).trim(),
            "fm1_oper",
            "fm1_oper_2code",
          );

          this.findLibValue(
            "oper_code",
            String(response.data.fm1_oper_3code).trim(),
            "fm1_oper",
            "fm1_oper_3code",
          );

          this.fm1_oper.fm1_oper_trouble_desc =
            response.data.fm1_oper_trouble_desc;

          this.fm1_oper.fm1_oper_add_info = response.data.fm1_oper_add_info;

          response.data.members.forEach((member) => {
            let member_tmp = {};

            // axios.get(window.base+'/library?type=org_form&query=&qty=1000'+'&lang='+this.$i18n.locale)
            // .then(response=>{
            // 	response.data.forEach(item=>{
            // 		if(item.value==member.fm1_memb_org_form){
            // 			member_tmp.fm1_memb_org_form.value = item
            // 		}
            // 		if(item.value==member.fm1_memb_founder_org_form) {
            // 			member_tmp.fm1_memb_founder_org_form = item
            // 		}
            // 	})
            // })

            // member_tmp.fm1_member = member.fm1_member
            // if(member_tmp.fm1_member==='' || member_tmp.fm1_member==false)
            // 	member_tmp.fm1_member = []
            // else
            // 	member_tmp.fm1_member = member_tmp.fm1_member.split(',')

            // member_tmp.fm1_memb_is_subj = member.fm1_memb_is_subj

            if (member.fm1_member) member_tmp.fm1_member = member.fm1_member;

            //!!!

            axios
              .get(
                window.base +
                  "/library?type=fm1_memb_subj_kind&query=&qty=1000" +
                  "&lang=" +
                  this.$i18n.locale,
              )
              .then((resp) => {
                resp.data.forEach((item) => {
                  if (item.value == String(member.fm1_memb_subj_kind).trim()) {
                    member_tmp.fm1_memb_subj_kind = item;
                  }
                });
              });

            // this.findLibValue('fm1_memb_subj_kind', String(member.fm1_memb_subj_kind).trim(), 'fm1_members', 'fm1_memb_subj_kind')
            // !!!
            axios
              .get(
                window.base +
                  "/library/country?code=" +
                  String(member.fm1_memb_country).trim() +
                  "&lang=" +
                  this.$i18n.locale,
              )
              .then((resp) => {
                member_tmp.fm1_memb_country = resp.data[0];
              });
            // this.findLibValue('country', , 'fm1_members', 'fm1_memb_country')

            member_tmp.fm1_memb_type = member.fm1_memb_type;

            member_tmp.fm1_memb_foreign = member.fm1_memb_foreign;

            member_tmp.fm1_memb_bank_branch_place =
              member.fm1_memb_bank_branch_place;

            member_tmp.fm1_memb_bank_branch = member.fm1_memb_bank_branch;

            member_tmp.fm1_memb_sdp = member.fm1_memb_sdp;

            member_tmp.fm1_memb_branch_code = member.fm1_memb_branch_code;

            member_tmp.fm1_memb_acc = member.fm1_memb_acc;

            member_tmp.fm1_memb_bank_place = member.fm1_memb_bank_place;

            member_tmp.fm1_memb_bank_name = member.fm1_memb_bank_name;

            member_tmp.fm1_memb_org_form =
              this.fm1_memb_org_forms[
                this.fm1_memb_org_forms.findIndex(
                  (i) => i.value == String(member.fm1_memb_org_form).trim(),
                )
              ];

            member_tmp.fm1_memb_company_name = member.fm1_memb_company_name;

            member_tmp.fm1_memb_noname = member.fm1_memb_noname;

            member_tmp.fm1_memb_founder_org_form =
              this.fm1_memb_org_forms[
                this.fm1_memb_org_forms.findIndex(
                  (i) =>
                    i.value == String(member.fm1_memb_founder_org_form).trim(),
                )
              ];

            member_tmp.fm1_memb_founder_ = member.fm1_memb_founder_;

            member_tmp.fm1_memb_founder_secondname =
              member.fm1_memb_founder_secondname;

            member_tmp.fm1_memb_founder_name = member.fm1_memb_founder_name;

            member_tmp.fm1_memb_founder_patronymic =
              member.fm1_memb_founder_patronymic;

            //!!!
            axios
              .get(
                window.base +
                  "/library/country?code=" +
                  String(member.fm1_memb_country_2).trim() +
                  "&lang=" +
                  this.$i18n.locale,
              )
              .then((resp) => {
                member_tmp.fm1_memb_country_2 = resp.data[0];
              });
            // this.findLibValue('country', String(member.fm1_memb_country_2).trim(), 'fm1_members', 'fm1_memb_country_2')
            //!!!
            // axios.get(window.base+'/library/oked?code='+String(response.data.oked).trim()+'&lang='+this.$i18n.locale).then(resp=>{
            // 	member_tmp.oked = resp.data[0]
            // })

            member_tmp.oked =
              this.okeds[
                this.okeds.findIndex(
                  (i) => i.value == String(member.oked).trim(),
                )
              ];
            // this.findLibValue('oked', String(response.data.oked).trim(), 'fm1_members', 'oked')

            member_tmp.iin_bin = member.iin_bin;

            member_tmp.fm1_person_secondname = member.fm1_person_secondname;
            member_tmp.fm1_person_name = member.fm1_person_name;
            member_tmp.fm1_person_midle_name = member.fm1_person_midle_name;
            member_tmp.fm1_person_secondname_2 = member.fm1_person_secondname_2;
            member_tmp.fm1_person_name_2 = member.fm1_person_name_2;
            member_tmp.fm1_person_middle_name_2 =
              member.fm1_person_middle_name_2;
            member_tmp.fm1_person_birth_date = member.fm1_person_birth_date;
            member_tmp.fm1_person_birth_place = member.fm1_person_birth_place;

            member_tmp.doc_type_2 = member.doc_type_2;
            member_tmp.doc_num_2 = member.doc_num_2;
            member_tmp.doc_series_2 = member.doc_series_2;
            member_tmp.goverm_office_2 = member.goverm_office_2;
            member_tmp.doc_date_2 = member.doc_date_2;
            member_tmp.state_kaz_2 = member.state_kaz_2;
            member_tmp.region_kaz_2 = member.region_kaz_2;
            member_tmp.sity_kaz_2 = member.sity_kaz_2;
            member_tmp.street_2 = member.street_2;
            member_tmp.house_num_2 = member.house_num_2;
            member_tmp.flat_num_2 = member.flat_num_2;
            member_tmp.post_index_2 = member.post_index_2;
            member_tmp.fm1_memb_contact_phone_2 =
              member.fm1_memb_contact_phone_2;
            member_tmp.fm1_memb_email_2 = member.fm1_memb_email_2;
            member_tmp.state_kaz_3 = member.state_kaz_3;
            member_tmp.region_kaz_3 = member.region_kaz_3;
            member_tmp.sity_kaz_3 = member.sity_kaz_3;
            member_tmp.street_3 = member.street_3;
            member_tmp.house_num_3 = member.house_num_3;
            member_tmp.flat_num_3 = member.flat_num_3;
            member_tmp.post_index_3 = member.post_index_3;
            member_tmp.fm1_memb_memb_add_info_3 =
              member.fm1_memb_memb_add_info_3;

            this.fm1_members_list.push(member_tmp);
          });
        });
    },
    stringifyProducts() {
      var result = [];
      this.CMRGoods.forEach((product, index) => {
        var line = "";

        line = "product[" + index + "].GoodMarking=" + product.GoodMarking;
        line +=
          "&product[" +
          index +
          "].GoodsDescription=" +
          product.GoodsDescription;
        line +=
          "&product[" + index + "].GoodsQuantity=" + product.GoodsQuantity;
        line +=
          "&product[" +
          index +
          "].GrossWeightQuantity=" +
          product.GrossWeightQuantity;
        line +=
          "&product[" +
          index +
          "].GoodsNomenclatureCode=" +
          product.GoodsNomenclatureCode;
        line +=
          "&product[" + index + "].VolumeQuantity=" + product.VolumeQuantity;

        // if(typeof product.GoodsCode !=='undefined')
        // 	line += '&product['+index+'].GoodsCode='+product.GoodsCode.value
        // if(typeof product.OriginCountryCode !=='undefined')
        // 	line += '&product['+index+'].OriginCountryCode='+product.OriginCountryCode.value
        // if(typeof product.SupplementaryQualifierName !=='undefined')
        // 	line += '&product['+index+'].SupplementaryQualifierName='+product.SupplementaryQualifierName.value

        result.push(line);
      });
      return result.join("&");
    },
    compileErrors() {
      const h = this.$createElement;
      let text = [];

      text.push(
        h("div", { domProps: { innerHTML: this.$t("message.errors-dialog") } }),
      );
      if (this.$v.fm1_main.$anyError) {
        text.push(
          h("div", {
            domProps: {
              innerHTML:
                this.$t("message.errors-at-tab") +
                this.$t("message.contracts.fm1_tab1_short"),
            },
          }),
        );
      }
      if (this.$v.fm1_subject.$anyError) {
        text.push(
          h("div", {
            domProps: {
              innerHTML:
                this.$t("message.errors-at-tab") +
                this.$t("message.contracts.fm1_tab2_short"),
            },
          }),
        );
      }
      if (this.$v.fm1_oper.$anyError) {
        text.push(
          h("div", {
            domProps: {
              innerHTML:
                this.$t("message.errors-at-tab") +
                this.$t("message.contracts.fm1_tab3_short"),
            },
          }),
        );
      }
      // if(this.$v.fm1_members.$anyError){
      // 	text.push(h('div', {domProps: {innerHTML: this.$t('message.errors-at-tab')+this.$t('message.contracts.fm1_tab4_short')}}))
      // }

      return h("div", {}, text);
    },
    addMemberData(data, isSeller) {
      var tmp = {
        fm1_member: [],
        fm1_memb_is_subj: false,
        fm1_memb_subj_kind: { value: "", display_text: "" },
        fm1_memb_country: { value: "", display_text: "" },
        fm1_memb_type: "",
        fm1_memb_foreign: "",
        fm1_memb_bank_branch_place: "",
        fm1_memb_bank_branch: "",
        fm1_memb_sdp: "",
        fm1_memb_branch_code: "",
        fm1_memb_acc: "",
        fm1_memb_bank_place: "",
        fm1_memb_bank_name: "",
        fm1_memb_org_form: { value: "", display_text: "" },
        fm1_memb_company_name: "",
        fm1_memb_noname: "",
        fm1_memb_founder_org_form: { value: "", display_text: "" },
        fm1_memb_founder_: "",
        fm1_memb_founder_secondname: "",
        fm1_memb_founder_name: "",
        fm1_memb_founder_patronymic: "",
        fm1_memb_country_2: { value: "", display_text: "" },
        oked: { value: "", display_text: "" },
        iin_bin: "",
        fm1_person_secondname: "",
        fm1_person_name: "",
        fm1_person_midle_name: "",
        fm1_person_secondname_2: "",
        fm1_person_name_2: "",
        fm1_person_middle_name_2: "",
        doc_type_2: "",
        doc_num_2: "",
        doc_series_2: "",
        goverm_office_2: "",
        doc_date_2: "",
        fm1_person_birth_date: "",
        fm1_person_birth_place: "",
        state_kaz_2: "",
        region_kaz_2: "",
        sity_kaz_2: "",
        street_2: "",
        house_num_2: "",
        flat_num_2: "",
        post_index_2: "",
        fm1_memb_contact_phone_2: "",
        fm1_memb_email_2: "",
        state_kaz_3: "",
        region_kaz_3: "",
        sity_kaz_3: "",
        street_3: "",
        house_num_3: "",
        flat_num_3: "",
        post_index_3: "",
        fm1_memb_memb_add_info_3: "",
      };
      // var type = this.fm1_memb_subj_kinds.filter(obj => {
      // 	return (data.organizations.org_type.trim() === obj.value.trim())
      // })
      if (isSeller) tmp.fm1_member = 2;
      else tmp.fm1_member = 1;

      if (typeof data.organizations.company_ceo != "undefined") {
        var ceo_arr = data.organizations.company_ceo.split(/\s+/);
        tmp.fm1_person_secondname = ceo_arr[0];
        tmp.fm1_person_name = ceo_arr[1];
        tmp.fm1_person_midle_name = ceo_arr[2];
      }

      tmp.fm1_person_secondname_2 = data.persons.last_name;
      tmp.fm1_person_name_2 = data.persons.given_name;
      tmp.fm1_person_middle_name_2 = data.persons.middle_name;

      if (data.organizations.org_type != null) {
        axios
          .get(
            window.base +
              "/library/org_type?code=" +
              data.organizations.org_type +
              "&lang=" +
              this.$i18n.locale,
          )
          .then((res1) => {
            //this.fm1_members.fm1_memb_org_form.value = response.data.organizations.org_type;
            tmp.fm1_memb_org_form = res1.data[0];
            // this.fm1_members.fm1_memb_founder_org_form.option.value = response.data.organizations.org_type;
            tmp.fm1_memb_founder_org_form = res1.data[0];
            tmp.fm1_memb_subj_kind = res1.data[0];
          });
      }

      tmp.fm1_memb_company_name = data.organizations.org_name;

      if (_.isArray(data.banks) && !_.isEmpty(data.banks)) {
        tmp.fm1_memb_bank_name = data.banks[0].subj_bank_acc_number;
        tmp.fm1_memb_bank_name = data.banks[0].subj_bank_name;
      }

      if (_.isArray(data.founders) && !_.isEmpty(data.founders)) {
        tmp.fm1_memb_founder_ = data.founders.org_founders_company;
        tmp.fm1_memb_founder_name = data.founders.org_founders_person_name;
        tmp.fm1_memb_country_2 = data.founders.org_founders_country;
      }

      var address_1 = data.addresses[0];
      var address_3 = data.addresses[2];
      if (typeof address_1 != "undefined") {
        tmp.state_kaz_2 = address_1.post_addr_district;
        tmp.region_kaz_2 = address_1.post_addr_region;
        tmp.sity_kaz_2 = address_1.post_addr_city;
        tmp.street_2 = address_1.post_addr_streethouse;
        tmp.house_num_2 = address_1.post_addr_house;
        tmp.flat_num_2 = address_1.post_addr_room;
        tmp.post_index_2 = address_1.post_addr_index;
        tmp.fm1_memb_contact_phone_2 = address_1.post_addr_comm_number;
      }
      if (typeof address_3 != "undefined") {
        tmp.state_kaz_3 = address_3.post_addr_district;
        tmp.region_kaz_3 = address_3.post_addr_region;
        tmp.sity_kaz_3 = address_3.post_addr_city;
        tmp.street_3 = address_3.post_addr_streethouse;
        tmp.house_num_3 = address_3.post_addr_house;
        tmp.flat_num_3 = address_3.post_addr_room;
        tmp.post_index_3 = address_3.post_addr_index;
      }

      if (
        _.isArray(data.person_documents) &&
        !_.isEmpty(data.person_documents)
      ) {
        tmp.doc_num_2 = data.person_documents[0].document_number;
        tmp.doc_series_2 = data.person_documents[0].document_serial;
        tmp.goverm_office_2 = data.person_documents[0].document_issued_by;
        tmp.doc_date_2 = data.person_documents[0].document_date;
        tmp.fm1_person_birth_date = data.persons.date_of_birth;

        axios
          .get(
            window.base +
              "/library?type=pa_document_type&query=&qty=1000" +
              "&lang=" +
              this.$i18n.locale,
          )
          .then((response) => {
            response.data.forEach((item) => {
              if (item.value == data.person_documents[0].document_type) {
                tmp.doc_type_2 = item.display_text;
              }
            });
          });
      }

      tmp.fm1_memb_country = data.org_residency;

      tmp.fm1_memb_country = data.org_residency;
      if (data.banks !== null && typeof data.banks[0] !== "undefined") {
        tmp.fm1_memb_bank_branch_place = data.banks[0].subj_bank_address;
        tmp.fm1_memb_bank_branch = data.banks[0].subj_bank_name;
        tmp.fm1_memb_branch_code = data.banks[0].subj_bank_bin;
        tmp.fm1_memb_acc = data.banks[0].subj_bank_acc_number;
        tmp.fm1_memb_bank_place = data.banks[0].subj_bank_address;
        tmp.fm1_memb_bank_name = data.banks[0].subj_bank_name;
      }
      if (data.founders !== null && typeof data.founders[0] !== "undefined") {
        tmp.fm1_memb_company_name = data.organizations.org_name;
        tmp.fm1_memb_founder_ = data.founders[0].org_founders_company;
        tmp.fm1_memb_founder_name = data.founders[0].org_founders_person_name;

        var country = this.countries.filter((obj) => {
          return data.founders[0].org_founders_country.trim() === obj.value;
        });
        tmp.fm1_memb_country_2 = country[0];
      }
      this.fm1_members_list.push(tmp);
    },
    saveDocument(data) {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.form_error = true;

        this.$bvModal.msgBoxOk(this.compileErrors(), {
          title: this.$t("message.errors-dialog-title"),
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: this.$t("message.ok"),
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        });
        // setTimeout(()=>{
        // $('html,body').animate({scrollTop: $('.has-danger').eq(0).offset().top-50}, 1000)
        // }, 100)
      } else {
        this.$root.$emit("show-loading");
        this.buttons_loading = true;
        // var fromData = new FormData();
        let fromData = {};
        fromData.document_category = "finance";
        // fromData.append('file', this.document.file)
        fromData.attis_contract_doc_date =
          this.document.attis_contract_doc_date;
        fromData.attis_contract_doc_number =
          this.document.attis_contract_doc_number;

        fromData.fm1_main_related_number =
          this.fm1_main.fm1_main_related_number;
        fromData.fm1_main_related_date = this.fm1_main.fm1_main_related_date;
        fromData.fm1_main_date = this.fm1_main.fm1_main_date;
        if (
          typeof this.fm1_main.fm1_main_doc_kind !== "undefined" &&
          typeof this.fm1_main.fm1_main_doc_kind.value !== "undefined"
        )
          fromData.fm1_main_doc_kind = this.fm1_main.fm1_main_doc_kind.value;
        else fromData.fm1_main_doc_kind = "";
        if (
          typeof this.fm1_main.fm1_main_form_state !== "undefined" &&
          typeof this.fm1_main.fm1_main_form_state.value !== "undefined"
        )
          fromData.fm1_main_form_state =
            this.fm1_main.fm1_main_form_state.value;
        else fromData.fm1_main_form_state = "";
        if (
          typeof this.fm1_main.fm1_main_reason !== "undefined" &&
          typeof this.fm1_main.fm1_main_reason.value !== "undefined"
        )
          fromData.fm1_main_reason = this.fm1_main.fm1_main_reason.value;
        else fromData.fm1_main_reason = "";
        if (
          typeof this.fm1_main.fm1_main_subreason !== "undefined" &&
          typeof this.fm1_main.fm1_main_subreason.value !== "undefined"
        )
          fromData.fm1_main_subreason = this.fm1_main.fm1_main_subreason.value;
        else fromData.fm1_main_subreason = "";

        fromData.fm1_subj_code = this.fm1_subject.fm1_subj_code;
        if (
          typeof this.fm1_subject.fm1_subj_org_form !== "undefined" &&
          typeof this.fm1_subject.fm1_subj_org_form.value !== "undefined"
        )
          fromData.fm1_subj_org_form = this.fm1_subject.fm1_subj_org_form.value;
        else fromData.fm1_subj_org_form = "";
        fromData.fm1_subj_name = this.fm1_subject.fm1_subj_name;
        fromData.fm1_subj_pers_second_name =
          this.fm1_subject.fm1_subj_pers_second_name;
        fromData.fm1_subj_pers_name = this.fm1_subject.fm1_subj_pers_name;
        fromData.fm1_subj_pers_middle_name =
          this.fm1_subject.fm1_subj_pers_middle_name;
        fromData.fm1_subj_rnn = this.fm1_subject.fm1_subj_rnn;
        fromData.fm1_subj_iin_bin = this.fm1_subject.fm1_subj_iin_bin;
        fromData.fm1_subj_manager_second_name =
          this.fm1_subject.fm1_subj_manager_second_name;
        fromData.fm1_subj_manager_name = this.fm1_subject.fm1_subj_manager_name;
        fromData.fm1_subj_manager_patronymic =
          this.fm1_subject.fm1_subj_manager_patronymic;
        fromData.fm1_subj_position = this.fm1_subject.fm1_subj_position;
        fromData.fm1_subj_phone = this.fm1_subject.fm1_subj_phone;
        fromData.fm1_subj_email = this.fm1_subject.fm1_subj_email;

        fromData.state_kaz_1 = this.fm1_addrr.state_kaz;
        fromData.region_kaz_1 = this.fm1_addrr.region_kaz;
        fromData.sity_kaz_1 = this.fm1_addrr.sity_kaz;
        fromData.street_1 = this.fm1_addrr.street;
        fromData.house_num_1 = this.fm1_addrr.house_num;
        fromData.flat_num_1 = this.fm1_addrr.flat_num;
        fromData.post_index_1 = this.fm1_addrr.post_index;

        fromData.doc_num = this.fm1_docs.doc_num;
        fromData.doc_series = this.fm1_docs.doc_series;
        fromData.goverm_office = this.fm1_docs.goverm_office;
        fromData.doc_date = this.fm1_docs.doc_date;

        fromData.fm1_oper_number = this.fm1_oper.fm1_oper_number;
        if (
          typeof this.fm1_oper.fm1_oper_code_type !== "undefined" &&
          typeof this.fm1_oper.fm1_oper_code_type.value !== "undefined"
        )
          fromData.fm1_oper_code_type = this.fm1_oper.fm1_oper_code_type.value;
        else fromData.fm1_oper_code_type = "";
        if (
          typeof this.fm1_oper.fm1_oper_eknp !== "undefined" &&
          typeof this.fm1_oper.fm1_oper_eknp.value !== "undefined"
        )
          fromData.fm1_oper_eknp = this.fm1_oper.fm1_oper_eknp.value;
        else fromData.fm1_oper_eknp = "";
        fromData.fm1_oper_members_quant = this.fm1_oper.fm1_oper_members_quant;
        if (
          typeof this.fm1_oper.fm1_oper_currency !== "undefined" &&
          typeof this.fm1_oper.fm1_oper_currency.value !== "undefined"
        )
          fromData.fm1_oper_currency = this.fm1_oper.fm1_oper_currency.value;
        else fromData.fm1_oper_currency = "";
        fromData.fm1_oper_curr_code = this.fm1_oper.fm1_oper_curr_code;
        fromData.fm1_oper_tenge_sum = this.fm1_oper.fm1_oper_tenge_sum;
        if (
          typeof this.fm1_oper.fm1_oper_basis !== "undefined" &&
          typeof this.fm1_oper.fm1_oper_basis.value !== "undefined"
        )
          fromData.fm1_oper_basis = this.fm1_oper.fm1_oper_basis.value;
        else fromData.fm1_oper_basis = "";
        fromData.fm1_oper_basis_doc_date =
          this.fm1_oper.fm1_oper_basis_doc_date;
        fromData.fm1_oper_basis_doc_num = this.fm1_oper.fm1_oper_basis_doc_num;
        if (
          typeof this.fm1_oper.fm1_oper_1code !== "undefined" &&
          typeof this.fm1_oper.fm1_oper_1code.value !== "undefined"
        )
          fromData.fm1_oper_1code = this.fm1_oper.fm1_oper_1code.value;
        else fromData.fm1_oper_1code = "";
        if (
          typeof this.fm1_oper.fm1_oper_2code !== "undefined" &&
          typeof this.fm1_oper.fm1_oper_2code.value !== "undefined"
        )
          fromData.fm1_oper_2code = this.fm1_oper.fm1_oper_2code.value;
        else fromData.fm1_oper_2code = "";
        if (
          typeof this.fm1_oper.fm1_oper_3code !== "undefined" &&
          typeof this.fm1_oper.fm1_oper_3code.value !== "undefined"
        )
          fromData.fm1_oper_3code = this.fm1_oper.fm1_oper_3code.value;
        else fromData.fm1_oper_3code = "";
        fromData.fm1_oper_trouble_desc = this.fm1_oper.fm1_oper_trouble_desc;
        fromData.fm1_oper_add_info = this.fm1_oper.fm1_oper_add_info;

        fromData.fm1_member = this.fm1_members.fm1_member;
        fromData.fm1_memb_is_subj = this.fm1_members.fm1_memb_is_subj;
        if (
          typeof this.fm1_members.fm1_memb_subj_kind !== "undefined" &&
          typeof this.fm1_members.fm1_memb_subj_kind.value !== "undefined"
        )
          fromData.fm1_memb_subj_kind =
            this.fm1_members.fm1_memb_subj_kind.value;
        else fromData.fm1_memb_subj_kind = "";
        if (
          typeof this.fm1_members.fm1_memb_country !== "undefined" &&
          typeof this.fm1_members.fm1_memb_country.value !== "undefined"
        )
          fromData.fm1_memb_country = this.fm1_members.fm1_memb_country.value;
        else fromData.fm1_memb_country = "";
        fromData.fm1_memb_type = this.fm1_members.fm1_memb_type;
        fromData.fm1_memb_foreign = this.fm1_members.fm1_memb_foreign;
        fromData.fm1_memb_bank_branch_place =
          this.fm1_members.fm1_memb_bank_branch_place;
        fromData.fm1_memb_bank_branch = this.fm1_members.fm1_memb_bank_branch;
        fromData.fm1_memb_sdp = this.fm1_members.fm1_memb_sdp;
        fromData.fm1_memb_branch_code = this.fm1_members.fm1_memb_branch_code;
        fromData.fm1_memb_acc = this.fm1_members.fm1_memb_acc;
        fromData.fm1_memb_bank_place = this.fm1_members.fm1_memb_bank_place;
        fromData.fm1_memb_bank_name = this.fm1_members.fm1_memb_bank_name;
        if (
          typeof this.fm1_members.fm1_memb_org_form !== "undefined" &&
          typeof this.fm1_members.fm1_memb_org_form.value !== "undefined"
        )
          fromData.fm1_memb_org_form = this.fm1_members.fm1_memb_org_form.value;
        else fromData.fm1_memb_org_form = "";
        fromData.fm1_memb_company_name = this.fm1_members.fm1_memb_company_name;
        fromData.fm1_memb_noname = this.fm1_members.fm1_memb_noname;
        if (
          typeof this.fm1_members.fm1_memb_founder_org_form !== "undefined" &&
          typeof this.fm1_members.fm1_memb_founder_org_form.value !==
            "undefined"
        )
          fromData.fm1_memb_founder_org_form =
            this.fm1_members.fm1_memb_founder_org_form.value;
        else fromData.fm1_memb_founder_org_form = "";
        fromData.fm1_memb_founder_ = this.fm1_members.fm1_memb_founder_;
        fromData.fm1_memb_founder_secondname =
          this.fm1_members.fm1_memb_founder_secondname;
        fromData.fm1_memb_founder_name = this.fm1_members.fm1_memb_founder_name;
        fromData.fm1_memb_founder_patronymic =
          this.fm1_members.fm1_memb_founder_patronymic;
        if (
          typeof this.fm1_members.fm1_memb_country_2 !== "undefined" &&
          typeof this.fm1_members.fm1_memb_country_2.value !== "undefined"
        )
          fromData.fm1_memb_country_2 =
            this.fm1_members.fm1_memb_country_2.value;
        else fromData.fm1_memb_country_2 = "";

        fromData.members = this.fm1_members_list.map((item) => {
          if (
            typeof item.fm1_memb_country !== "undefined" &&
            typeof item.fm1_memb_country.value !== "undefined"
          )
            item.fm1_memb_country = item.fm1_memb_country.value;
          if (
            typeof item.fm1_memb_country_2 !== "undefined" &&
            typeof item.fm1_memb_country_2.value !== "undefined"
          )
            item.fm1_memb_country_2 = item.fm1_memb_country_2.value;
          if (
            typeof item.fm1_memb_subj_kind !== "undefined" &&
            typeof item.fm1_memb_subj_kind.value !== "undefined"
          )
            item.fm1_memb_subj_kind = item.fm1_memb_subj_kind.value;
          if (
            typeof item.fm1_memb_founder_org_form !== "undefined" &&
            typeof item.fm1_memb_founder_org_form.value !== "undefined"
          )
            item.fm1_memb_founder_org_form =
              item.fm1_memb_founder_org_form.value;
          if (
            typeof item.fm1_memb_org_form !== "undefined" &&
            typeof item.fm1_memb_org_form.value !== "undefined"
          )
            item.fm1_memb_org_form = item.fm1_memb_org_form.value;
          if (
            typeof item.oked !== "undefined" &&
            typeof item.oked.value !== "undefined"
          )
            item.oked = item.oked.value;
          if (
            typeof item.fm1_member !== "undefined" &&
            item.fm1_member !== null
          )
            item.fm1_member = item.fm1_member[0];
          return item;
        });

        // Attach file
        // fromData.append('file', data.document.file);
        // console.log(tmp, data.document, this.stringifyProducts())
        var t1 = this.$t("message.error");
        setTimeout(() => {
          axios
            .post(
              window.base +
                (this.is_new === true
                  ? "/Document/CreateFM1" +
                    "?attis_contract_id=" +
                    this.$route.params.id
                  : "/Document/UpdateFM1" +
                    "?attis_contract_id=" +
                    this.document_id),
              fromData /*, {headers: { 'Content-Type': 'multipart/form-data' }}*/,
            )
            .then((response) => {
              if (response.data == "ok") {
                new Noty({
                  theme: "light",
                  type: "success",
                  text: this.$root.$t("message.message.fm1-created"),
                  timeout: 5000,
                }).show();
                this.$root.$emit("loadDocuments", { category: "all" });
                this.$root.$emit(
                  "bv::hide::modal",
                  "modal-document",
                  "#btnShow",
                );
                this.$root.$emit(
                  "bv::hide::modal",
                  "modal-document-new",
                  "#btnShow",
                );
                this.buttons_loading = false;
              } else {
                new Noty({
                  theme: "light",
                  type: "error",
                  text:
                    this.$root.$t("message.message.fm1-not-created") +
                    " (" +
                    response.data +
                    ")",
                  timeout: 5000,
                }).show();
                // if (window.dev_mode) {
                //   this.$root.$emit(
                //     "bv::hide::modal",
                //     "modal-document",
                //     "#btnShow",
                //   );
                //   this.$root.$emit(
                //     "bv::hide::modal",
                //     "modal-document-new",
                //     "#btnShow",
                //   );
                // }
                this.buttons_loading = false;
              }
            })
            .catch((e) => {
              this.buttons_loading = false;
              new Noty({
                theme: "light",
                type: "error",
                text: t1,
                timeout: 5000,
              }).show();
              this.$root.$emit("bv::hide::modal", "modal-document", "#btnShow");
              this.$root.$emit(
                "bv::hide::modal",
                "modal-document-new",
                "#btnShow",
              );
            });
        }, 800);
      }
    },
  },
  mounted() {
    this.fetchCurrencies();
    this.fetchContragents("");
    this.fetchTNVED("");
    this.fetchMeasures("");
    this.fetchCountries("");
    this.fetchFm1OperBasis("");
    this.fetchorg_form("");
    this.fetchFm1OperCode("");
    this.fetchFm1CodeType("");
    this.fetchFm1CodeEknp("");
    this.fetchOkeds("");
    this.fetchMembSubjKind("");

    if (this.document_id == "new") {
      var contragent = "";
      var isSeller = false;
      if (this.contract_details.attis_contract_type) {
        contragent = this.contract_details.attis_contract_contragent;
      } else {
        contragent = this.contract_details.attis_contract_contragent;
        isSeller = true;
      }
      axios
        .get(
          window.base +
            "/document/fm1InitialData?contragent=" +
            contragent.value +
            "&isSeller=" +
            isSeller,
        )
        .then((response) => {
          if (response.data.seller.organizations.org_code != null)
            this.addMemberData(response.data.seller, true);
          if (response.data.buyer.organizations.org_code != null)
            this.addMemberData(response.data.buyer, false);
          //load personal data for the company
          axios.get(window.base + "/document/getFirmFull").then((response) => {
            this.$store.commit("load_firm", response.data);
            this.fm1_subject.fm1_subj_name =
              response.data.organizations.org_name;
            this.fm1_subject.fm1_subj_pers_second_name =
              response.data.persons.last_name;
            this.fm1_subject.fm1_subj_pers_name =
              response.data.persons.given_name;
            this.fm1_subject.fm1_subj_pers_middle_name =
              response.data.persons.middle_name;
            this.fm1_subject.fm1_subj_iin_bin =
              response.data.organizations.org_code;
            if (this.contract_details.attis_contract_type === true) {
              this.fm1_members.iin_bin = response.data.organizations.org_code;
            }

            this.fm1_addrr.state_kaz =
              response.data.addresses[0].post_addr_district;
            this.fm1_addrr.region_kaz =
              response.data.addresses[0].post_addr_region;
            this.fm1_addrr.sity_kaz = response.data.addresses[0].post_addr_town;
            this.fm1_addrr.street =
              response.data.addresses[0].post_addr_streethouse;
            this.fm1_addrr.house_num =
              response.data.addresses[0].post_addr_house;
            this.fm1_addrr.flat_num = response.data.addresses[0].post_addr_room;
            this.fm1_addrr.post_index =
              response.data.addresses[0].post_addr_index;

            this.fm1_subject.fm1_subj_manager_second_name =
              response.data.persons.last_name;
            this.fm1_subject.fm1_subj_manager_name =
              response.data.persons.given_name;
            this.fm1_subject.fm1_subj_manager_patronymic =
              response.data.persons.middle_name;
            this.fm1_subject.fm1_subj_position = response.data.persons.position;
            this.fm1_subject.fm1_subj_phone =
              response.data.persons.person_phone_number;
            this.fm1_subject.fm1_subj_email =
              response.data.persons.person_email;
          });
        });

      // if(this.contract_details.attis_contract_type===true){
      // 	this.fm1_members.fm1_member = [1]

      // 	axios.get(window.base+'/document/getFirm').then(response=>{
      // 		this.fm1_members.fm1_memb_company_name = response.data.display_text
      // 	})
      // }else{
      // 	this.fm1_members.fm1_member = [2]
      // 	this.fm1_members.fm1_memb_company_name = this.contract_details.attis_contract_contragent.display_text
      // }

      this.fm1_oper.fm1_oper_currency =
        this.contract_details.attis_contract_currency;
      this.fm1_oper.fm1_oper_basis_doc_date =
        this.contract_details.attis_contract_date;
      this.fm1_oper.fm1_oper_basis_doc_num = this.$route.params.id;

      //load invoice
      axios
        .get(
          window.base + "/document?attis_contract_id=" + this.$route.params.id,
        )
        .then((response) => {
          response.data.forEach((item) => {
            if (item.DocType == "Инвойс") {
              axios
                .get(
                  window.base +
                    "/Document/LoadInvoice/?doc_id=" +
                    item.DocumentID,
                )
                .then((response) => {
                  this.fm1_oper.fm1_oper_curr_code = response.data.TotalCost;
                });
            }
          });
        });
    } else {
      this.load();
    }

    this.$root.$on("saveDocument", (data) => {
      if (typeof data.document.attis_contract_doc_type === "object") {
        if (data.document.attis_contract_doc_type.value == "fm1") {
          this.saveDocument(data);
        }
      } else {
        if (data.document.attis_contract_doc_type == "fm1") {
          this.saveDocument(data);
        }
      }
    });
    this.$root.$on("set.buyer.contragent", (data) => {
      this.Invoice.InvoiceByer = {
        value: data.company.number,
        display_text: data.company.name,
      };
    });
    this.$root.$on("set.seller.contragent", (data) => {
      this.Invoice.InvoiceSeller = {
        value: data.company.number,
        display_text: data.company.name,
      };
    });
  },
  computed: {
    locale() {
      var locale = this.$i18n.locale;
      var _this = this;
      switch (locale) {
        case "cn":
          locale = "zh-CN";
          break;
        case "en":
          locale = "en-US";
          break;
      }
      return locale;
    },
    is_field_readonly() {
      if (this.fm1_main.IsSigned) return true;
      return false;
    },
  },
  validations() {
    var v = {
      fm1_main: {
        fm1_main_doc_kind: {
          required,
        },
        fm1_main_reason: {
          required,
        },
      },
      fm1_subject: {
        fm1_subj_code: {
          required,
        },
        fm1_subj_name: {
          required,
        },
        fm1_subj_rnn: {
          required,
        },
        fm1_subj_phone: {
          required,
        },
      },
      fm1_oper: {
        fm1_oper_number: {
          required,
        },
        fm1_oper_code_type: {
          required,
        },
        fm1_oper_eknp: {
          required,
        },
        fm1_oper_members_quant: {
          required,
        },
        fm1_oper_currency: {
          required,
        },
        fm1_oper_curr_code: {
          required,
        },
        fm1_oper_tenge_sum: {
          required,
        },
        fm1_oper_basis: {
          required,
        },
        fm1_oper_trouble_desc: {
          required,
        },
      },
      // fm1_members: {
      // 	fm1_member: {
      // 		required
      // 	},
      // 	fm1_memb_subj_kind: {
      // 		required
      // 	},
      // 	fm1_memb_type: {
      // 		required
      // 	}
      // }
    };
    if (this.is_fiz_lico) {
      v.fm1_docs = {
        doc_num: {
          required,
        },
        doc_series: {
          required,
        },
        goverm_office: {
          required,
        }
      };
    }
    return v;
  },
};
</script>
